"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2126],{

/***/ 65167:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hJ": function() { return /* binding */ ImageGallery; }
/* harmony export */ });
/* unused harmony exports Accordion, AccordionContent, AccordionItem, AccordionPanel, AccordionTrigger, Badge, BaseText, Body, Breadcrumb, BreadcrumbEllipsis, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, Breadcrumbs, Button, Checkbox, Chronology, ChronologyContent, ChronologyItem, ChronologyLabel, CreditCard, Cvv, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, Divider, ErrorMessage, Heading, Image, ImageCarousel, Input, InputField, Label, MOTIF_LOADER_DEFAULTS, Modal, MotifDivider, MotifLoader, Radio, RadioGroup, Select, SelectField, Skeleton, Small, Spinner, TextArea, TextAreaField, Toggle, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, badgeVariants, bgColorMap, borderColorMap, buttonVariants, checkboxVariants, cn, dialogContentVariants, dialogOverlayVariants, dividerVariants, getBgColorClass, getBorderColorClass, getColorCssVar, getTextColorClass, inputVariants, resolveColor, resolveMargins, selectVariants, spinnerVariants, textAreaVariants, textColorMap, tooltipContentVariants */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90512);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98388);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12003);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70609);
/* harmony import */ var _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77407);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88426);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77667);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57434);












// src/utils/cn.ts
function cn(...inputs) {
  return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_2__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_3__/* .clsx */ .W)(inputs));
}

// src/utils/tokens.ts
var legacyToSemanticMap = {
  black: "neutral-1000",
  white: "neutral-0",
  light: "neutral-0",
  dark: "neutral-900",
  "grey-dark": "neutral-700",
  "grey-medium": "neutral-400",
  "grey-light": "neutral-50",
  "grey-light-medium": "neutral-200",
  "gold-dark": "brand-primary",
  "gold-medium": "brand-subtle",
  "gold-light": "brand-subtle-light",
  "gold-very-dark": "brand-primary-hover",
  "forms-red": "status-error",
  "forms-green": "status-success",
  red: "status-error",
  "blue-dark": "brand-complementary",
  primary: "neutral-900"
};
function resolveColor(color) {
  if (color in legacyToSemanticMap) {
    return legacyToSemanticMap[color];
  }
  return color;
}
var alignClassMap = {
  left: "text-left",
  center: "text-center",
  right: "text-right"
};
var textColorMap = {
  "neutral-0": "text-neutral-0",
  "neutral-50": "text-neutral-50",
  "neutral-100": "text-neutral-100",
  "neutral-200": "text-neutral-200",
  "neutral-300": "text-neutral-300",
  "neutral-400": "text-neutral-400",
  "neutral-500": "text-neutral-500",
  "neutral-600": "text-neutral-600",
  "neutral-700": "text-neutral-700",
  "neutral-800": "text-neutral-800",
  "neutral-900": "text-neutral-900",
  "neutral-1000": "text-neutral-1000",
  "brand-editorial": "text-brand-editorial",
  "brand-primary": "text-brand-primary",
  "brand-complementary": "text-brand-complementary",
  "brand-primary-hover": "text-brand-primary-hover",
  "brand-primary-pressed": "text-brand-primary-pressed",
  "brand-primary-disabled": "text-brand-primary-disabled",
  "brand-subtle": "text-brand-subtle",
  "brand-subtle-light": "text-brand-subtle-light",
  "status-success": "text-status-success",
  "status-error": "text-status-error",
  "status-info": "text-status-info",
  "status-warning": "text-status-warning"
};
var bgColorMap = {
  "neutral-0": "bg-neutral-0",
  "neutral-50": "bg-neutral-50",
  "neutral-100": "bg-neutral-100",
  "neutral-200": "bg-neutral-200",
  "neutral-300": "bg-neutral-300",
  "neutral-400": "bg-neutral-400",
  "neutral-500": "bg-neutral-500",
  "neutral-600": "bg-neutral-600",
  "neutral-700": "bg-neutral-700",
  "neutral-800": "bg-neutral-800",
  "neutral-900": "bg-neutral-900",
  "neutral-1000": "bg-neutral-1000",
  "brand-primary": "bg-brand-primary",
  "brand-primary-hover": "bg-brand-primary-hover",
  "brand-primary-pressed": "bg-brand-primary-pressed",
  "brand-primary-disabled": "bg-brand-primary-disabled",
  "brand-complementary": "bg-brand-complementary",
  "brand-subtle": "bg-brand-subtle",
  "brand-subtle-light": "bg-brand-subtle-light",
  "status-success": "bg-status-success",
  "status-success-bg": "bg-status-success-bg",
  "status-error": "bg-status-error",
  "status-error-bg": "bg-status-error-bg",
  "status-info": "bg-status-info",
  "status-info-bg": "bg-status-info-bg",
  "status-warning": "bg-status-warning",
  "status-warning-bg": "bg-status-warning-bg"
};
var borderColorMap = {
  "neutral-0": "border-neutral-0",
  "neutral-200": "border-neutral-200",
  "neutral-300": "border-neutral-300",
  "neutral-400": "border-neutral-400",
  "brand-editorial": "border-brand-editorial",
  "brand-primary": "border-brand-primary",
  "brand-primary-disabled": "border-brand-primary-disabled",
  "brand-subtle": "border-brand-subtle",
  "brand-subtle-light": "border-brand-subtle-light",
  "status-success": "border-status-success",
  "status-error": "border-status-error",
  "status-info": "border-status-info",
  "status-warning": "border-status-warning"
};

// src/utils/colorProps.ts
function getTextColorClass(color) {
  if (!color) return void 0;
  return textColorMap[resolveColor(color)];
}
function getBgColorClass(color) {
  if (!color) return void 0;
  return bgColorMap[resolveColor(color)];
}
function getBorderColorClass(color) {
  if (!color) return void 0;
  return borderColorMap[resolveColor(color)];
}
function getColorCssVar(color) {
  return `var(--color-${resolveColor(color)})`;
}
function getBackgroundStyle(color) {
  if (color === "transparent") return "transparent";
  return getColorCssVar(color);
}

// src/utils/margins.ts
var pxToSuffix = {
  0: "0",
  1: "px",
  2: "0.5",
  4: "1",
  5: "[5px]",
  6: "1.5",
  8: "2",
  10: "2.5",
  12: "3",
  14: "3.5",
  15: "[15px]",
  16: "4",
  20: "5",
  24: "6",
  28: "7",
  30: "[30px]",
  32: "8",
  36: "9",
  40: "10",
  44: "11",
  48: "12",
  56: "14",
  64: "16",
  80: "20",
  96: "24"
};
for (const dir of ["mt", "mb", "ml", "mr"]) {
  for (const [, suffix] of Object.entries(pxToSuffix)) {
  }
}
function resolveOneMargin(direction, value) {
  if (value === void 0 || value === null) return {};
  if (typeof value === "number") {
    const suffix = pxToSuffix[value];
    if (suffix) {
      const cls = `${direction}-${suffix}`;
      return { className: cls };
    }
    return {
      style: {
        [direction === "mt" ? "marginTop" : direction === "mb" ? "marginBottom" : direction === "ml" ? "marginLeft" : "marginRight"]: value
      }
    };
  }
  const prop = direction === "mt" ? "marginTop" : direction === "mb" ? "marginBottom" : direction === "ml" ? "marginLeft" : "marginRight";
  return { style: { [prop]: value } };
}
function resolveMargins(margins) {
  const classes = [];
  let style;
  for (const [dir, val] of [
    ["mt", margins.mt],
    ["mb", margins.mb],
    ["ml", margins.ml],
    ["mr", margins.mr]
  ]) {
    const result = resolveOneMargin(dir, val);
    if (result.className) classes.push(result.className);
    if (result.style) style = { ...style, ...result.style };
  }
  return { className: classes.join(" "), style };
}
var weightClassMap = {
  regular: "font-normal",
  medium: "font-medium",
  demiBold: "font-semibold",
  semibold: "font-semibold",
  heavy: "font-[800]"
};
var weightAliases = {
  demibold: "semibold",
  normal: "regular"
};
function resolveWeight(weight, type) {
  const raw = weight ?? type;
  if (!raw) return void 0;
  return weightAliases[raw] ?? raw;
}
var BaseText = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    as,
    color,
    weight,
    type,
    link,
    isLink,
    italic,
    fontStyle,
    align,
    fontSize,
    letterSpacing,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    children,
    ...rest
  }, ref) => {
    const Component = as || "p";
    const resolvedWeight = resolveWeight(weight, type);
    const resolvedLink = link ?? isLink;
    const resolvedItalic = italic ?? (fontStyle === "italic" ? true : fontStyle === "normal" ? false : void 0);
    const resolvedColor = color ? resolveColor(color) : void 0;
    const colorClass = resolvedColor ? textColorMap[resolvedColor] : void 0;
    const alignClass = align ? alignClassMap[align] : void 0;
    const margins = resolveMargins({ mt, mb, ml, mr });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      Component,
      {
        ref,
        className: cn(
          "font-sans m-0 p-0 tracking-[0]",
          resolvedWeight && weightClassMap[resolvedWeight],
          resolvedLink && "underline cursor-pointer",
          resolvedItalic && "italic",
          colorClass,
          alignClass,
          margins.className,
          className
        ),
        style: margins.style || style || fontSize !== void 0 || letterSpacing !== void 0 ? {
          ...margins.style,
          ...fontSize !== void 0 ? { fontSize } : {},
          ...letterSpacing !== void 0 ? { letterSpacing } : {},
          ...style
        } : void 0,
        ...rest,
        children
      }
    );
  }
);
BaseText.displayName = "BaseText";
var headingSizeClasses = {
  h1: "text-[36px]",
  h2: "text-[32px]",
  h3: "text-[28px]",
  h4: "text-[24px]",
  h5: "text-lg"
};
var headingDefaultWeight = {
  h1: "semibold",
  h2: "semibold",
  h3: "semibold",
  h4: "semibold",
  h5: "medium"
};
var Heading = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    as,
    color = "neutral-900",
    weight,
    className,
    ...rest
  }, ref) => {
    const tag = as || "h2";
    const resolvedWeight = weight ?? headingDefaultWeight[tag];
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      BaseText,
      {
        as: tag,
        ref,
        color,
        weight: resolvedWeight,
        className: cn("leading-[120%]", headingSizeClasses[tag], className),
        ...rest
      }
    );
  }
);
Heading.displayName = "Heading";
var bodyVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("break-words", {
  variants: {
    size: {
      default: "text-base leading-[140%]",
      sm: "text-sm leading-[140%]"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
var Body = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    as,
    size,
    color = "neutral-800",
    weight = "regular",
    className,
    ...rest
  }, ref) => {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      BaseText,
      {
        as: as || "p",
        ref,
        color,
        weight,
        className: cn(bodyVariants({ size }), className),
        ...rest
      }
    );
  }
);
Body.displayName = "Body";
var smallVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("", {
  variants: {
    xs: {
      true: "text-xs leading-[140%]",
      false: "text-sm leading-[140%]"
    },
    error: {
      true: "text-status-error",
      false: ""
    }
  },
  defaultVariants: {
    xs: false,
    error: false
  }
});
var Small = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    as,
    xs,
    error,
    color = error ? void 0 : "neutral-600",
    weight = "regular",
    className,
    ...rest
  }, ref) => {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      BaseText,
      {
        as: as || "small",
        ref,
        color: error ? void 0 : color,
        weight,
        className: cn(smallVariants({ xs, error }), className),
        ...rest
      }
    );
  }
);
Small.displayName = "Small";
var badgeVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "inline-flex max-w-full px-3 py-0.5 items-center justify-center rounded-2xl",
  {
    variants: {
      variant: {
        primary: "bg-brand-subtle border border-brand-editorial",
        ghost: "bg-neutral-0 border border-brand-editorial",
        light: "bg-brand-subtle-light",
        "primary-black": "bg-neutral-900",
        "secondary-white": "bg-neutral-0 border border-neutral-200",
        "secondary-dark-grey": "bg-neutral-700",
        danger: "bg-status-error"
      }
    },
    defaultVariants: { variant: "primary" }
  }
);
var variantTextColor = {
  primary: "neutral-900",
  ghost: "neutral-900",
  light: "neutral-900",
  "primary-black": "neutral-0",
  "secondary-white": "neutral-800",
  "secondary-dark-grey": "neutral-0",
  danger: "neutral-0"
};
var Badge = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    variant = "primary",
    className,
    children,
    backgroundColor,
    textColor,
    ...rest
  }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "span",
    {
      ...rest,
      ref,
      className: cn(
        badgeVariants({ variant }),
        backgroundColor && getBgColorClass(backgroundColor),
        className
      ),
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        Body,
        {
          as: "span",
          size: "sm",
          color: textColor ?? variantTextColor[variant ?? "primary"],
          className: "wrap-break-word",
          children
        }
      )
    }
  )
);
Badge.displayName = "Badge";
var buttonVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "font-sans inline-flex items-center justify-center gap-2 whitespace-nowrap rounded font-semibold cursor-pointer border-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        "primary-gold": "bg-brand-primary text-neutral-1000 hover:bg-brand-primary-hover active:bg-brand-primary-pressed disabled:bg-brand-primary-disabled disabled:text-neutral-400",
        "primary-black": "bg-neutral-900 text-neutral-0 hover:bg-neutral-800 active:bg-neutral-700 disabled:bg-neutral-300 disabled:text-neutral-400",
        "secondary-ghost": "bg-transparent border border-neutral-300 text-neutral-800 hover:bg-neutral-50 active:bg-neutral-100 disabled:text-neutral-400 disabled:border-neutral-200",
        "secondary-white": "bg-neutral-0 border border-neutral-200 text-neutral-800 hover:bg-neutral-50 active:bg-neutral-100 disabled:text-neutral-400",
        "secondary-gold": "bg-transparent border border-brand-primary text-brand-primary hover:bg-brand-subtle-light active:bg-brand-subtle disabled:text-brand-primary-disabled disabled:border-brand-primary-disabled",
        "secondary-dark-grey": "bg-neutral-700 text-neutral-0 hover:bg-neutral-600 active:bg-neutral-800 disabled:bg-neutral-300 disabled:text-neutral-400",
        danger: "bg-status-error text-neutral-0 hover:bg-status-error/90 active:bg-status-error/80 disabled:bg-neutral-300 disabled:text-neutral-400"
      },
      size: {
        xs: "h-7 px-2 text-xs rounded",
        sm: "h-8 px-3 text-sm rounded",
        md: "h-10 px-4 text-sm rounded-md",
        lg: "h-12 px-6 text-base rounded-md",
        full: "h-12 w-full px-6 text-base rounded-md"
      }
    },
    defaultVariants: {
      variant: "primary-gold",
      size: "md"
    }
  }
);
var sizeAliases = {
  small: "sm",
  medium: "md",
  large: "lg"
};
var Spinner = () => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    className: "animate-spin h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "circle",
        {
          className: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          className: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    ]
  }
);
var Button = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    as,
    variant,
    size,
    isLoading = false,
    iconLeft,
    iconRight,
    disabled,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    children,
    ...rest
  }, ref) => {
    const Component = as || "button";
    const isDisabled = disabled || isLoading;
    const resolvedSize = typeof size === "string" && size in sizeAliases ? sizeAliases[size] : size;
    const margins = resolveMargins({ mt, mb, ml, mr });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      Component,
      {
        ref,
        disabled: Component === "button" ? isDisabled : void 0,
        "aria-disabled": isDisabled || void 0,
        "aria-busy": isLoading || void 0,
        className: cn(
          buttonVariants({ variant, size: resolvedSize }),
          margins.className,
          className
        ),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        ...rest,
        children: [
          isLoading ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Spinner, {}) : iconLeft,
          children,
          !isLoading && iconRight
        ]
      }
    );
  }
);
Button.displayName = "Button";
var dividerVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("shrink-0 border-0", {
  variants: {
    orientation: {
      horizontal: "h-px w-full",
      vertical: "w-px h-full"
    },
    color: {
      default: "bg-neutral-200",
      subtle: "bg-neutral-100",
      strong: "bg-neutral-300",
      brand: "bg-brand-subtle"
    },
    spacing: {
      none: "",
      sm: "",
      md: "",
      lg: ""
    }
  },
  compoundVariants: [
    { orientation: "horizontal", spacing: "sm", className: "my-2" },
    { orientation: "horizontal", spacing: "md", className: "my-4" },
    { orientation: "horizontal", spacing: "lg", className: "my-8" },
    { orientation: "vertical", spacing: "sm", className: "mx-2" },
    { orientation: "vertical", spacing: "md", className: "mx-4" },
    { orientation: "vertical", spacing: "lg", className: "mx-8" }
  ],
  defaultVariants: {
    orientation: "horizontal",
    color: "default",
    spacing: "none"
  }
});
var directionAliases = {
  h: "horizontal",
  v: "vertical"
};
var namedColors = /* @__PURE__ */ new Set(["default", "subtle", "strong", "brand"]);
var Divider = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    as,
    orientation,
    direction,
    color,
    spacing,
    height,
    width,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    ...rest
  }, ref) => {
    const Component = as || "hr";
    const resolvedOrientation = orientation ?? (direction ? directionAliases[direction] : void 0);
    let cvaColor = "default";
    let tokenBgClass;
    if (color && namedColors.has(color)) {
      cvaColor = color;
    } else if (color) {
      cvaColor = null;
      const resolved = resolveColor(color);
      tokenBgClass = bgColorMap[resolved];
    }
    const margins = resolveMargins({ mt, mb, ml, mr });
    const inlineStyle = height !== void 0 || width !== void 0 || margins.style || style ? {
      ...margins.style,
      ...height !== void 0 ? { height } : {},
      ...width !== void 0 ? { width } : {},
      ...style
    } : void 0;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      Component,
      {
        ref,
        role: "separator",
        "aria-orientation": resolvedOrientation || "horizontal",
        className: cn(
          dividerVariants({
            orientation: resolvedOrientation,
            color: cvaColor,
            spacing
          }),
          tokenBgClass,
          margins.className,
          className
        ),
        style: inlineStyle,
        ...rest
      }
    );
  }
);
Divider.displayName = "Divider";
var MotifDivider = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    className = "",
    backgroundColor = "neutral-0",
    color = "neutral-900",
    loadingText = "",
    animated = false,
    ...rest
  }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
    "div",
    {
      ref,
      "data-color": backgroundColor,
      className: cn(
        "flex flex-col gap-s20 items-center justify-center",
        className
      ),
      style: { backgroundColor: getBackgroundStyle(backgroundColor) },
      ...rest,
      children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "w-full flex items-center justify-center", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "220",
            height: "19",
            viewBox: "0 0 220 19",
            fill: "none",
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", { children: "Divider" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", { x1: "75", y1: "8.5", x2: "85", y2: "8.5", stroke: "#505050", children: animated && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
                "animate",
                {
                  attributeName: "x1",
                  values: "75; 0; 75",
                  dur: "2s",
                  repeatCount: "indefinite",
                  calcMode: "linear"
                }
              ) }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", { cx: "104.5", cy: "9.5", r: "9", stroke: "#505050" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", { cx: "115.5", cy: "9.5", r: "9", stroke: "#505050" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", { x1: "135", y1: "9.5", x2: "145", y2: "9.5", stroke: "#505050", children: animated && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
                "animate",
                {
                  attributeName: "x2",
                  values: "145; 220; 145",
                  dur: "2s",
                  repeatCount: "indefinite",
                  calcMode: "linear"
                }
              ) })
            ]
          }
        ) }),
        loadingText && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          Heading,
          {
            as: "h5",
            color,
            className: "italic font-normal leading-[120%] opacity-100 translate-x-[10px] animate-currentString",
            children: loadingText
          }
        )
      ]
    }
  )
);
MotifDivider.displayName = "MotifDivider";

// src/primitives/motif-loader/constants.ts
var MOTIF_LOADING_TEXTS = [
  "Fluffing the pillows...",
  "Turning down the beds...",
  "Stocking the mini-bar...",
  "Confirming your booking..."
];
var MOTIF_LOADER_INTERVAL_TIME = 1e3;
var MOTIF_LOADER_DEFAULTS = {
  loadingText: MOTIF_LOADING_TEXTS,
  backgroundColor: "neutral-0"
};
var MotifLoader = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    loadingText = MOTIF_LOADER_DEFAULTS.loadingText,
    backgroundColor = MOTIF_LOADER_DEFAULTS.backgroundColor,
    animationDelay = MOTIF_LOADER_INTERVAL_TIME,
    className,
    ...rest
  }, ref) => {
    const [displayText, setDisplayText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
      void 0
    );
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
      if (loadingText.length === 0) {
        setDisplayText(void 0);
        return;
      }
      const pickRandom = () => loadingText[Math.floor(Math.random() * loadingText.length)];
      setDisplayText(pickRandom());
      const intervalId = window.setInterval(() => {
        setDisplayText(pickRandom());
      }, animationDelay);
      return () => window.clearInterval(intervalId);
    }, [loadingText, animationDelay]);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "div",
      {
        ref,
        className: cn("opacity-100 animate-fadeIn", className),
        style: { animationDelay: `${animationDelay}s` },
        ...rest,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          MotifDivider,
          {
            backgroundColor,
            ...displayText && { loadingText: displayText },
            animated: true
          }
        )
      }
    );
  }
);
MotifLoader.displayName = "MotifLoader";
var CloseIcon = () => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { d: "M18 6 6 18" }),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { d: "m6 6 12 12" })
    ]
  }
);
var Dialog = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Root */ .fC;
var DialogTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Trigger */ .xz;
var DialogPortal = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Portal */ .h_;
var DialogClose = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8;
var dialogOverlayVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "fixed inset-0 z-50",
  {
    variants: {
      variant: {
        default: "bg-black/70",
        dark: "bg-black/80",
        light: "bg-black/50"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var DialogOverlay = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, variant, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Overlay */ .aV,
  {
    ref,
    className: cn(dialogOverlayVariants({ variant }), className),
    ...props
  }
));
DialogOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Overlay.displayName */ .aV.displayName;
var dialogContentVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "fixed left-1/2 top-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 gap-4 border p-6 shadow-lg font-sans focus:outline-none",
  {
    variants: {
      size: {
        sm: "max-w-sm rounded-md",
        md: "max-w-lg rounded-md",
        lg: "max-w-2xl rounded-md",
        full: "max-w-[calc(100%-2rem)] rounded-md",
        unconstrained: "rounded-md"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
var DialogContent = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(
  ({
    className,
    children,
    size,
    hideClose = false,
    showClose = true,
    backgroundColor = "neutral-0",
    borderColor = "neutral-200",
    ...props
  }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DialogPortal, { children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogOverlay, {}),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Content */ .VY,
      {
        ref,
        className: cn(
          dialogContentVariants({ size }),
          getBgColorClass(backgroundColor),
          getBorderColorClass(borderColor),
          className
        ),
        ...props,
        children: [
          children,
          showClose && !hideClose && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
            _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8,
            {
              className: "absolute right-4 top-4 rounded-sm opacity-70 text-neutral-700 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 disabled:pointer-events-none",
              "aria-label": "Close",
              children: [
                /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseIcon, {}),
                /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] })
);
DialogContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Content.displayName */ .VY.displayName;
var DialogHeader = ({
  className,
  ...props
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "div",
  {
    className: cn(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      className
    ),
    ...props
  }
);
DialogHeader.displayName = "DialogHeader";
var DialogFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "div",
  {
    className: cn(
      "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:space-x-2",
      className
    ),
    ...props
  }
);
DialogFooter.displayName = "DialogFooter";
var DialogTitle = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, color = "neutral-900", ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx,
  {
    ref,
    className: cn(
      "text-lg font-semibold leading-none tracking-tight",
      getTextColorClass(color),
      className
    ),
    ...props
  }
));
DialogTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Title.displayName */ .Dx.displayName;
var DialogDescription = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, color = "neutral-600", ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Description */ .dk,
  {
    ref,
    className: cn("text-sm", getTextColorClass(color), className),
    ...props
  }
));
DialogDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Description.displayName */ .dk.displayName;
function Modal({
  children,
  isOpen,
  open,
  onOpen,
  onClose,
  onOpenChange,
  onRequestClose,
  className,
  title,
  showCloseIcon = true,
  showOverlay = true
}) {
  const resolvedOpen = open ?? isOpen ?? false;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (resolvedOpen) {
      onOpen?.();
    }
  }, [resolvedOpen, onOpen]);
  const handleOpenChange = (nextOpen) => {
    onOpenChange?.(nextOpen);
    if (!nextOpen) {
      onClose?.();
      onRequestClose?.();
    }
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Dialog, { modal: true, open: resolvedOpen, onOpenChange: handleOpenChange, children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogTitle, { className: "sr-only", children: title ?? "Dialog" }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogDescription, { className: "sr-only", children: title ?? "Dialog content" }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DialogPortal, { children: [
      showOverlay && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogOverlay, {}),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
        _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Content */ .VY,
        {
          className: cn(
            "fixed left-1/2 top-1/2 z-50 w-full -translate-x-1/2 -translate-y-1/2 bg-neutral-0 shadow-lg font-sans focus:outline-none",
            className
          ),
          children: [
            showCloseIcon && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8,
              {
                className: "absolute right-4 top-4 z-10 rounded-sm opacity-70 text-neutral-700 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 disabled:pointer-events-none",
                onClick: () => handleOpenChange(false),
                "aria-label": "Close",
                children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseIcon, {})
              }
            ),
            children
          ]
        }
      )
    ] })
  ] });
}
Modal.displayName = "Modal";
var ChevronIcon = ({ className }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
    "aria-hidden": "true",
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { d: "m6 9 6 6 6-6" })
  }
);
var Accordion = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Root */ .fC;
var AccordionItem = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Item */ .ck,
  {
    ref,
    className: cn("border-b border-neutral-200", className),
    ...props
  }
));
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, children, hideIcon = false, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Header */ .h4, { className: "flex", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Trigger */ .xz,
  {
    ref,
    className: cn(
      "flex flex-1 items-center justify-between py-4 font-sans text-left text-sm font-medium text-neutral-900 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 [&[data-state=open]>svg]:rotate-180",
      className
    ),
    ...props,
    children: [
      children,
      !hideIcon && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChevronIcon, { className: "h-5 w-5 shrink-0 text-neutral-700 transition-transform duration-200" })
    ]
  }
) }));
AccordionTrigger.displayName = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Trigger.displayName */ .xz.displayName;
var AccordionContent = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Content */ .VY,
  {
    ref,
    className: "overflow-hidden text-sm transition-all",
    ...props,
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: cn("pb-4 pt-0 font-sans text-neutral-700", className), children })
  }
));
AccordionContent.displayName = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_6__/* .Content.displayName */ .VY.displayName;
function AccordionPanel({
  children,
  title,
  heading,
  isOpen = false,
  onClick,
  renderHeader,
  headerClass,
  className,
  style
}) {
  const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [contentHeight, setContentHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const updateContentHeight = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (contentRef.current && isOpen) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    updateContentHeight();
  }, [isOpen, children, updateContentHeight]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!contentRef.current || !isOpen) {
      return;
    }
    const observer = new ResizeObserver(() => {
      updateContentHeight();
    });
    observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, [isOpen, updateContentHeight]);
  const panelTitle = title ?? heading;
  const headerContent = renderHeader?.() ?? (panelTitle ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex flex-1 items-center justify-between gap-3", children: [
    typeof panelTitle === "string" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { weight: "semibold", children: panelTitle }) : panelTitle,
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      ChevronIcon,
      {
        className: cn(
          "h-5 w-5 shrink-0 text-neutral-700 transition-transform duration-200",
          isOpen && "rotate-180"
        )
      }
    )
  ] }) : null);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: cn("font-sans", className), style, children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "button",
      {
        type: "button",
        className: cn(
          "flex w-full items-center border-0 bg-transparent p-0 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2",
          headerClass
        ),
        "aria-expanded": isOpen,
        onClick,
        children: headerContent
      }
    ),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "div",
      {
        style: { maxHeight: isOpen ? contentHeight : 0 },
        className: "overflow-hidden transition-[max-height] duration-200 ease-in-out",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { ref: contentRef, className: "pb-4 pt-2", children })
      }
    )
  ] });
}
AccordionPanel.displayName = "AccordionPanel";
var Skeleton = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    className,
    containerClassName,
    width = "100%",
    height = "20px",
    count = 1,
    backgroundColor = "neutral-100",
    style,
    ...rest
  }, ref) => {
    const skeletonStyle = {
      width,
      height,
      ...style
    };
    const skeletonClassName = cn(
      "animate-pulse rounded-md",
      getBgColorClass(backgroundColor),
      className
    );
    if (count <= 1) {
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "div",
        {
          ref,
          className: skeletonClassName,
          style: skeletonStyle,
          ...rest
        }
      );
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "div",
      {
        ref,
        className: cn("flex flex-col gap-2.5", containerClassName),
        ...rest,
        children: Array.from({ length: count }, (_, index) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "div",
          {
            className: skeletonClassName,
            style: skeletonStyle
          },
          index
        ))
      }
    );
  }
);
Skeleton.displayName = "Skeleton";
var spinnerVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("inline-block animate-spin", {
  variants: {
    size: {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-8 w-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var sizeAliases2 = {
  small: "sm",
  medium: "md",
  large: "lg"
};
var SPINNER_PATH = "M11.0095 0C5.30359 0 0 4.91561 0 11C0.010887 11.5528 0.0466087 12.0904 0.114666 12.5673C0.3199 13.9116 1.0489 14.2264 1.65333 14.1729C1.96071 14.1457 2.23668 14.0028 2.41789 13.7715C2.59024 13.5515 2.69703 13.2464 2.62813 12.7967C2.6137 12.7344 2.60838 12.665 2.59948 12.6056C2.49963 12.0901 2.42745 11.5532 2.42745 11C2.42745 6.27009 6.28064 2.43702 11.0095 2.43702C15.7284 2.43702 19.5725 6.27009 19.5725 11C19.5725 15.7199 15.7294 19.563 11.0095 19.563C9.94486 19.563 8.93555 19.3728 8.00868 19.0278C6.48544 18.3831 5.49341 20.4434 7.04344 21.2642C8.25074 21.8348 9.81147 21.9914 11.0095 22C17.0832 22 22 17.0844 22 11C21.8955 4.62382 16.4385 0.0902439 11.0095 0Z";
function resolveSpinnerFill(color) {
  if (color === "currentColor") return "currentColor";
  return getColorCssVar(color);
}
var Spinner2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    className,
    size,
    pixelSize,
    color = "neutral-900",
    role = "status",
    "aria-label": ariaLabel = "Loading",
    ...rest
  }, ref) => {
    const resolvedSize = typeof size === "string" && size in sizeAliases2 ? sizeAliases2[size] : size;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "div",
      {
        ref,
        className: cn("inline-flex items-center justify-center", className),
        role,
        "aria-label": ariaLabel,
        ...rest,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "svg",
          {
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: cn(!pixelSize && spinnerVariants({ size: resolvedSize })),
            style: pixelSize ? { width: pixelSize, height: pixelSize } : void 0,
            "aria-hidden": "true",
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: SPINNER_PATH,
                fill: resolveSpinnerFill(color)
              }
            )
          }
        )
      }
    );
  }
);
Spinner2.displayName = "Spinner";
var ChevronRightIcon = ({ className }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
    "aria-hidden": "true",
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { d: "m9 18 6-6-6-6" })
  }
);
var MoreHorizontalIcon = ({ className }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", { cx: "12", cy: "12", r: "1" }),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", { cx: "19", cy: "12", r: "1" }),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", { cx: "5", cy: "12", r: "1" })
    ]
  }
);
var Breadcrumb = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", { ref, "aria-label": "Breadcrumb", ...props }));
Breadcrumb.displayName = "Breadcrumb";
var BreadcrumbList = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "ol",
  {
    ref,
    className: cn(
      "flex flex-wrap items-center gap-1.5 break-words font-sans text-sm text-neutral-600 sm:gap-2.5",
      className
    ),
    ...props
  }
));
BreadcrumbList.displayName = "BreadcrumbList";
var BreadcrumbItem = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "li",
  {
    ref,
    className: cn("inline-flex items-center gap-1.5", className),
    ...props
  }
));
BreadcrumbItem.displayName = "BreadcrumbItem";
var BreadcrumbLink = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ asChild, className, ...props }, ref) => {
  const Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_7__/* .Slot */ .g7 : "a";
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    Comp,
    {
      ref,
      className: cn(
        "text-neutral-900 transition-colors hover:text-neutral-700",
        className
      ),
      ...props
    }
  );
});
BreadcrumbLink.displayName = "BreadcrumbLink";
var BreadcrumbPage = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "span",
  {
    ref,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: cn("font-normal text-neutral-500", className),
    ...props
  }
));
BreadcrumbPage.displayName = "BreadcrumbPage";
var BreadcrumbSeparator = ({
  children,
  className,
  ...props
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: cn("[&>svg]:h-3.5 [&>svg]:w-3.5", className),
    ...props,
    children: children ?? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChevronRightIcon, {})
  }
);
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
var BreadcrumbEllipsis = ({
  className,
  ...props
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: cn("flex h-9 w-9 items-center justify-center", className),
    ...props,
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MoreHorizontalIcon, { className: "h-4 w-4" }),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", { className: "sr-only", children: "More" })
    ]
  }
);
BreadcrumbEllipsis.displayName = "BreadcrumbEllipsis";
function Breadcrumbs({
  items,
  className,
  itemClassName,
  separator
}) {
  const lastIndex = items.length - 1;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Breadcrumb, { className, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BreadcrumbList, { children: items.map((item, index) => {
    const isLastItem = index === lastIndex;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BreadcrumbItem, { className: cn("text-xs", itemClassName), children: isLastItem ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BreadcrumbPage, { children: item.label }) : item.href ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BreadcrumbLink, { href: item.href, children: item.label }) : item.onClick ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BreadcrumbLink, { asChild: true, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "button",
        {
          type: "button",
          onClick: item.onClick,
          className: "border-0 bg-transparent p-0 font-inherit",
          children: item.label
        }
      ) }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", { className: "text-neutral-600", children: item.label }) }),
      !isLastItem && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BreadcrumbSeparator, { children: separator })
    ] }, `${item.label}-${index}`);
  }) }) });
}
Breadcrumbs.displayName = "Breadcrumbs";
var DefaultFallback = () => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "flex h-full w-full items-center justify-center text-neutral-400", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-1/2 w-1/2",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "rect",
        {
          x: "6",
          y: "10",
          width: "36",
          height: "28",
          rx: "2",
          stroke: "currentColor",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M6 32l10-10 8 8 6-6 12 12",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", { cx: "16", cy: "18", r: "3", stroke: "currentColor", strokeWidth: "2" })
    ]
  }
) });
var Image = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    src,
    alt,
    className,
    style,
    fallback,
    objectFit = "cover",
    backgroundColor,
    placeholderBackground = "neutral-50",
    onError,
    ...rest
  }, ref) => {
    const [hasError, setHasError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!src);
    const resolvedPlaceholder = backgroundColor ?? placeholderBackground;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
      setHasError(!src);
    }, [src]);
    const showFallback = hasError || !src;
    if (showFallback) {
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "div",
        {
          className: cn("overflow-hidden font-sans", className),
          style: {
            backgroundColor: getColorCssVar(resolvedPlaceholder),
            ...style
          },
          role: "img",
          "aria-label": alt,
          children: fallback ?? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DefaultFallback, {})
        }
      );
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "img",
      {
        ref,
        src,
        alt,
        className: cn("block max-w-full", className),
        style: { objectFit, ...style },
        onError: (event) => {
          setHasError(true);
          onError?.(event);
        },
        ...rest
      }
    );
  }
);
Image.displayName = "Image";
var TooltipProvider = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Provider */ .zt;
var Tooltip = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Root */ .fC;
var TooltipTrigger = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Trigger */ .xz;
var tooltipContentVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "z-50 font-sans text-xs leading-snug shadow-md",
  {
    variants: {
      variant: {
        /** Figma: Tooltip plain */
        plain: "max-w-xs rounded px-3 py-1.5",
        /** Figma: Tooltip side expanded — longer copy */
        expanded: "max-w-sm rounded-md px-3 py-2 text-left",
        /** Figma: Tooltip up short */
        short: "max-w-[12rem] rounded px-3 py-1.5"
      }
    },
    defaultVariants: {
      variant: "plain"
    }
  }
);
var TooltipContent = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(
  ({
    className,
    variant,
    color = "neutral-0",
    backgroundColor = "neutral-900",
    sideOffset = 6,
    showArrow = true,
    children,
    ...props
  }, ref) => {
    const resolvedBackground = backgroundColor;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Portal */ .h_, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Content */ .VY,
      {
        ref,
        sideOffset,
        className: cn(
          tooltipContentVariants({ variant }),
          getTextColorClass(color),
          getBgColorClass(resolvedBackground),
          className
        ),
        ...props,
        children: [
          children,
          showArrow && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Arrow */ .Eh,
            {
              style: { fill: getColorCssVar(resolvedBackground) },
              width: 10,
              height: 5
            }
          )
        ]
      }
    ) });
  }
);
TooltipContent.displayName = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Content.displayName */ .VY.displayName;
function ArrowLeft({ className, ...props }) {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "svg",
    {
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className,
      ...props,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15.75 19.5L8.25 12l7.5-7.5"
        }
      )
    }
  );
}
function ArrowRight({ className, ...props }) {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "svg",
    {
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className,
      ...props,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8.25 4.5l7.5 7.5-7.5 7.5"
        }
      )
    }
  );
}
function CloseIcon2({ className, ...props }) {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "svg",
    {
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className,
      ...props,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M6 18L18 6M6 6l12 12"
        }
      )
    }
  );
}
function VideoIcon({ className, ...props }) {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "svg",
    {
      "aria-hidden": "true",
      viewBox: "0 0 19 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      ...props,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.5 1.1875C4.90913 1.1875 1.1875 4.90913 1.1875 9.5C1.1875 14.0909 4.90913 17.8125 9.5 17.8125C14.0909 17.8125 17.8125 14.0909 17.8125 9.5C17.8125 4.90913 14.0909 1.1875 9.5 1.1875ZM0.3125 9.5C0.3125 4.42588 4.42588 0.3125 9.5 0.3125C14.5741 0.3125 18.6875 4.42588 18.6875 9.5C18.6875 14.5741 14.5741 18.6875 9.5 18.6875C4.42588 18.6875 0.3125 14.5741 0.3125 9.5ZM7.54356 5.61427C7.68582 5.53813 7.85843 5.54648 7.99268 5.63598L13.2427 9.13598C13.3644 9.21712 13.4375 9.35372 13.4375 9.5C13.4375 9.64628 13.3644 9.78288 13.2427 9.86402L7.99268 13.364C7.85843 13.4535 7.68582 13.4619 7.54356 13.3857C7.40131 13.3096 7.3125 13.1613 7.3125 13V6C7.3125 5.83865 7.40131 5.6904 7.54356 5.61427ZM8.1875 6.81748V12.1825L12.2113 9.5L8.1875 6.81748Z",
          fill: "currentColor"
        }
      )
    }
  );
}
var mediaClassName = "absolute inset-0 h-full w-full object-contain object-center";
function CarouselMedia({ item }) {
  if (item.type === "video") {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "video",
      {
        src: item.video_url,
        "aria-label": item.description ?? "",
        controls: true,
        className: mediaClassName,
        poster: item.thumbnail_url ?? "",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("track", { kind: "captions" })
      }
    );
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    Image,
    {
      src: item.image_url,
      alt: item.description ?? "",
      loading: "lazy",
      objectFit: "contain",
      className: mediaClassName
    }
  );
}
var imageCarouselVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "relative flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden"
);
function ImageCarousel({
  images,
  videos,
  initialIndex = 0,
  onIndexChange,
  renderImage,
  className,
  ariaLabel = "Image carousel"
}) {
  const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({ loop: true });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!emblaApi) {
      return;
    }
    emblaApi.scrollTo(initialIndex, true);
  }, [emblaApi, initialIndex]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!emblaApi) {
      return;
    }
    const onSelect = () => {
      onIndexChange?.(emblaApi.selectedScrollSnap());
    };
    emblaApi.on("select", onSelect);
    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi, onIndexChange]);
  const scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => emblaApi?.scrollNext(), [emblaApi]);
  const items = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return [
      ...images.map((img) => ({ ...img, type: "image" })),
      ...videos?.map((video) => ({ ...video, type: "video" })) ?? []
    ];
  }, [images, videos]);
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
    "section",
    {
      "aria-label": ariaLabel,
      className: cn(
        imageCarouselVariants(),
        className,
        "image-carousel-container"
      ),
      children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "div",
          {
            className: "h-full min-h-0 w-full flex-1 overflow-hidden",
            ref: emblaRef,
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "flex h-full w-full touch-pan-y", children: items.map((item, i) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
              "div",
              {
                className: cn(
                  "relative flex h-full min-h-0 w-full min-w-0 flex-[0_0_100%] flex-col",
                  "image-carousel-item"
                ),
                children: [
                  /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "relative mx-4 my-4 min-h-0 min-w-0 flex-1 md:mx-16", children: renderImage ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "absolute inset-0 flex items-center justify-center", children: renderImage(item, { context: "carousel", index: i }) }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CarouselMedia, { item }) }),
                  !renderImage && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
                    "div",
                    {
                      className: cn(
                        "image-carousel-description-container mx-auto shrink-0 px-4 py-3 text-center md:px-16",
                        !item.description && "invisible"
                      ),
                      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
                        Body,
                        {
                          size: "sm",
                          weight: "medium",
                          className: "image-carousel-description",
                          title: item.description ?? void 0,
                          children: item.description
                        }
                      )
                    }
                  )
                ]
              },
              item.type === "video" ? item.video_url ?? `video-${i}` : item.image_url ?? `image-${i}`
            )) })
          }
        ),
        items.length > 1 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "button",
          {
            type: "button",
            "aria-label": "Previous slide",
            onClick: scrollPrev,
            className: "hidden md:flex cursor-pointer absolute top-1/2 left-4 sm:left-6 -translate-y-1/2 h-12 w-12 items-center justify-center text-neutral-900 disabled:opacity-50 bg-transparent",
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowLeft, { className: "h-10 w-10" })
          }
        ),
        items.length > 1 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "button",
          {
            type: "button",
            "aria-label": "Next slide",
            onClick: scrollNext,
            className: "hidden md:flex cursor-pointer absolute top-1/2 right-4 sm:right-6 -translate-y-1/2 h-12 w-12 items-center justify-center text-neutral-900 disabled:opacity-50 bg-transparent",
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowRight, { className: "h-10 w-10" })
          }
        )
      ]
    }
  );
}
function ImageGalleryGrid({
  images,
  restoreIndex,
  onSelect,
  renderImage
}) {
  const itemRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const el = itemRefs.current[restoreIndex];
    if (el) {
      el.scrollIntoView({ block: "nearest" });
    }
  }, [restoreIndex]);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "flex-1 overflow-y-auto px-4 py-4 sm:px-6 m-auto w-full overscroll-contain", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", { className: "grid grid-cols-2 gap-2.5 list-none p-0 m-0 [&>li:nth-child(3n+1)]:col-span-2 max-w-[800px] mx-auto", children: images.map((img, i) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
    "li",
    {
      ref: (el) => {
        itemRefs.current[i] = el;
      },
      "data-index": i,
      className: "relative aspect-[4/3] overflow-hidden rounded-md",
      children: [
        renderImage ? renderImage(img, { context: "grid", index: i }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          Image,
          {
            src: img.image_url,
            alt: img.description ?? "",
            loading: "lazy",
            className: "h-full w-full"
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "button",
          {
            type: "button",
            "aria-label": img.description || `Photo ${i + 1}`,
            onClick: () => onSelect(i),
            className: "absolute inset-0 h-full w-full cursor-pointer border-0 bg-transparent p-0 focus-visible:outline-2 focus-visible:outline-brand-500"
          }
        )
      ]
    },
    img.image_url
  )) }) });
}
function ImageGalleryModalHeader({
  view,
  currentIndex,
  totalImages,
  itemType,
  onBack,
  onClose
}) {
  const iconButtonClass = cn(
    "flex h-10 w-10 items-center justify-center cursor-pointer",
    "text-neutral-900 hover:bg-neutral-100",
    "focus-visible:outline-2 focus-visible:outline-brand-500"
  );
  const showBackButton = view === "carousel" && totalImages > 1 && itemType === "image";
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex items-center justify-between px-4 py-3 sm:px-6", children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "div",
      {
        className: cn("flex items-center gap-2", {
          "w-5": view === "carousel" && totalImages <= 1
        }),
        children: showBackButton && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "button",
          {
            type: "button",
            "aria-label": "Back to gallery",
            onClick: onBack,
            className: iconButtonClass,
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowLeft, { className: "h-5 w-5" })
          }
        )
      }
    ),
    view === "carousel" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", { className: "text-sm font-medium text-neutral-700", children: [
      currentIndex + 1,
      " / ",
      totalImages
    ] }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "button",
      {
        type: "button",
        "aria-label": "Close gallery",
        onClick: onClose,
        className: iconButtonClass,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseIcon2, { className: "h-5 w-5" })
      }
    )
  ] });
}
var INITIAL = {
  isOpen: false,
  view: "grid",
  openIndex: 0,
  currentIndex: 0,
  itemType: "image"
};
function useImageGalleryModal(imagesCount = 0) {
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(INITIAL);
  const openGallery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (type) => {
      const viewOnImageCount = imagesCount <= 1 ? "carousel" : "grid";
      setState((prev) => {
        const resolvedType = type ?? prev.itemType;
        return {
          isOpen: true,
          view: resolvedType === "image" ? viewOnImageCount : "carousel",
          openIndex: 0,
          currentIndex: 0,
          itemType: resolvedType
        };
      });
    },
    [imagesCount]
  );
  const openCarouselAt = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((index) => {
    setState((prev) => ({
      ...prev,
      view: "carousel",
      openIndex: index,
      currentIndex: index,
      isOpen: prev.isOpen || true
    }));
  }, []);
  const backToGrid = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setState((prev) => ({
      ...prev,
      view: "grid"
    }));
  }, []);
  const setCurrentIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((index) => {
    setState((prev) => ({
      ...prev,
      currentIndex: index
    }));
  }, []);
  const closeModal = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setState({ ...INITIAL });
  }, []);
  return {
    state,
    openGallery,
    openCarouselAt,
    backToGrid,
    setCurrentIndex,
    closeModal
  };
}
function ImageGallery({
  images,
  renderImage,
  ariaLabel = "Image gallery",
  className,
  videos,
  defaultNoImageUrl = ""
}) {
  const gallery = useImageGalleryModal(images.length);
  const dialogRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const lastFocusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleOpenGallery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (images.length === 0) {
      return;
    }
    lastFocusRef.current = document.activeElement;
    gallery.openGallery("image");
  }, [gallery.openGallery, images.length]);
  const handleOpenGalleryVideo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if ((videos?.length ?? 0) === 0) {
      return;
    }
    lastFocusRef.current = document.activeElement;
    gallery.openGallery("video");
  }, [gallery.openGallery, videos?.length]);
  const handleDialogCancel = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      event.preventDefault();
      gallery.closeModal();
    },
    [gallery.closeModal]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }
    if (gallery.state.isOpen && !dialog.open) {
      dialog.showModal();
    } else if (!gallery.state.isOpen && dialog.open) {
      dialog.close();
    }
  }, [gallery.state.isOpen]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!gallery.state.isOpen && lastFocusRef.current) {
      lastFocusRef.current.focus();
      lastFocusRef.current = null;
    }
  }, [gallery.state.isOpen]);
  const heroImage = images?.[0] ?? { image_url: defaultNoImageUrl };
  if (images.length === 0 && defaultNoImageUrl.length <= 0) {
    return null;
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn(
          "relative flex w-full items-center justify-center overflow-hidden h-[236px] sm:h-[500px]",
          className
        ),
        children: [
          heroImage && "image_url" in heroImage && renderImage?.(heroImage, { context: "hero", index: 0 }),
          heroImage && "image_url" in heroImage && !renderImage && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            Image,
            {
              src: heroImage.image_url,
              alt: heroImage.description ?? "",
              loading: "eager",
              className: "h-full w-full"
            }
          ),
          (videos?.length ?? 0) > 0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            "button",
            {
              type: "button",
              "aria-label": "View all videos",
              onClick: handleOpenGalleryVideo,
              className: "absolute bottom-3 left-3 md:left-[calc(100%-(.75rem+190px))] z-100 rounded-sm bg-neutral-900/70 px-3 py-1.5 text-sm font-medium text-neutral-0 backdrop-blur-sm cursor-pointer border-0  p-0 focus-visible:outline-2 focus-visible:outline-brand-500 focus-visible:outline-offset-2",
              children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoIcon, { width: 20, height: 20 })
            }
          ),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            "button",
            {
              type: "button",
              "aria-label": "View all photos",
              onClick: handleOpenGallery,
              className: cn(
                "absolute inset-0 z-10 border-0 bg-transparent p-0 focus-visible:outline-2 focus-visible:outline-brand-500 focus-visible:outline-offset-2",
                {
                  "cursor-pointer": images.length >= 1
                }
              )
            }
          ),
          images.length > 1 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
            "div",
            {
              "aria-hidden": "true",
              className: "absolute bottom-3 right-3 z-10 rounded-sm bg-neutral-900/70 px-3 py-1.5 text-sm font-medium text-neutral-0 backdrop-blur-sm pointer-events-none select-none",
              children: [
                "View all ",
                images.length,
                " photos"
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "dialog",
      {
        ref: dialogRef,
        "aria-modal": "true",
        "aria-label": ariaLabel,
        onCancel: handleDialogCancel,
        className: cn(
          "fixed inset-0 m-0 h-screen w-screen max-h-none max-w-none border-0 bg-neutral-0 p-0",
          "backdrop:bg-neutral-900/60"
        ),
        children: gallery.state.isOpen && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex h-full min-h-0 w-full flex-col", children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            ImageGalleryModalHeader,
            {
              view: gallery.state.view,
              currentIndex: gallery.state.currentIndex,
              totalImages: gallery.state.itemType === "image" ? images.length : videos?.length ?? 0,
              itemType: gallery.state.itemType,
              onBack: gallery.backToGrid,
              onClose: gallery.closeModal
            }
          ),
          gallery.state.view === "grid" && gallery.state.itemType === "image" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            ImageGalleryGrid,
            {
              images: gallery.state.itemType === "image" ? images : [],
              restoreIndex: gallery.state.currentIndex,
              onSelect: gallery.openCarouselAt,
              renderImage
            }
          ) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            ImageCarousel,
            {
              images: gallery.state.itemType === "image" ? images : [],
              initialIndex: gallery.state.openIndex,
              onIndexChange: gallery.setCurrentIndex,
              renderImage,
              videos: gallery.state.itemType === "video" ? videos : []
            }
          )
        ] })
      }
    )
  ] });
}
var inputVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "font-sans bg-white border box-border rounded-[5px] text-sm text-neutral-1000 px-3 w-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-0 disabled:cursor-default disabled:bg-neutral-100",
  {
    variants: {
      size: {
        default: "h-[45px]",
        sm: "h-8 text-xs",
        lg: "h-12 text-base"
      },
      error: {
        true: "border-status-error",
        false: "border-neutral-300"
      }
    },
    defaultVariants: {
      size: "default",
      error: false
    }
  }
);
var Input = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({ size, error = false, className, ...props }, ref) => {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "input",
      {
        ref,
        className: cn(inputVariants({ size, error }), className),
        ...props
      }
    );
  }
);
Input.displayName = "Input";
var ErrorMessage = ({
  children,
  className,
  color = "status-error",
  ...rest
}) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "p",
    {
      className: cn(
        "font-sans text-sm leading-[140%] mt-2.5",
        getTextColorClass(color),
        className
      ),
      role: "alert",
      ...rest,
      children
    }
  );
};
ErrorMessage.displayName = "ErrorMessage";
var sizeAliases3 = {
  small: "sm",
  medium: "default",
  large: "lg"
};
function mergeRefs(...refs) {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref && typeof ref === "object") {
        ref.current = value;
      }
    }
  };
}
var InputField = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    label,
    labelProps,
    errorMsg,
    errorMessage,
    error,
    icon,
    width,
    size,
    inputRef,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    ...inputProps
  }, ref) => {
    const errorText = errorMsg ?? errorMessage;
    const hasErrorState = !!errorText || error === true;
    const resolvedSize = typeof size === "string" && size in sizeAliases3 ? sizeAliases3[size] : size;
    const mergedRef = mergeRefs(ref, inputRef);
    const margins = resolveMargins({ mt, mb, ml, mr });
    const iconElement = icon ? typeof icon === "string" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "img",
      {
        src: icon,
        className: "absolute left-2.5 w-[15px] h-[15px] pointer-events-none",
        alt: ""
      }
    ) : (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(icon) ? icon : null : null;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn("flex flex-col gap-1", margins.className, className),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        children: [
          label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { weight: "demiBold", ...labelProps, children: label }),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: cn("relative", iconElement && "flex items-center"), children: [
            iconElement,
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              Input,
              {
                ref: mergedRef,
                size: resolvedSize,
                error: hasErrorState,
                style: width !== void 0 ? { width } : void 0,
                className: cn(iconElement && "pl-[30px]"),
                ...inputProps
              }
            )
          ] }),
          errorText && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMessage, { children: errorText })
        ]
      }
    );
  }
);
InputField.displayName = "InputField";
var selectVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "font-sans bg-white border box-border rounded-[5px] text-sm text-neutral-1000 h-[45px] w-full px-3 pr-10 appearance-none cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-0 disabled:cursor-default disabled:bg-neutral-100",
  {
    variants: {
      error: {
        true: "border-status-error",
        false: "border-neutral-300"
      }
    },
    defaultVariants: {
      error: false
    }
  }
);
var ChevronIcon2 = () => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "svg",
  {
    className: "h-4 w-4 text-neutral-700",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { d: "M6 9l6 6 6-6" })
  }
);
var Select = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({ error = false, className, children, ...props }, ref) => {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "relative", children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "select",
        {
          ref,
          className: cn(selectVariants({ error }), className),
          ...props,
          children
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "pointer-events-none absolute inset-y-0 right-3 flex items-center", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChevronIcon2, {}) })
    ] });
  }
);
Select.displayName = "Select";
function mergeRefs2(...refs) {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === "function") ref(value);
      else if (ref && typeof ref === "object")
        ref.current = value;
    }
  };
}
var SelectField = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    label,
    labelProps,
    errorMsg,
    error,
    inputRef,
    width,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    children,
    ...selectProps
  }, ref) => {
    const hasError = !!errorMsg || error === true;
    const margins = resolveMargins({ mt, mb, ml, mr });
    const mergedRef = mergeRefs2(ref, inputRef);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn("flex flex-col gap-1", margins.className, className),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        children: [
          label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { weight: "demiBold", ...labelProps, children: label }),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            Select,
            {
              ref: mergedRef,
              error: hasError,
              style: width !== void 0 ? { width } : void 0,
              ...selectProps,
              children
            }
          ),
          errorMsg && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMessage, { children: errorMsg })
        ]
      }
    );
  }
);
SelectField.displayName = "SelectField";
var checkboxVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "bg-white border rounded-[5px] cursor-pointer appearance-none relative shrink-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-neutral-100 checked:bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2718%27%20height%3D%2713%27%20viewBox%3D%270%200%2018%2013%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cg%20clip-path%3D%27url%28%23clip0%29%27%3E%3Cpath%20d%3D%27M16.6905%200.8125L6.26086%2011.6405L6.52425%2011.914L6.78764%2012.1875L17.2174%201.3594L16.954%201.08595L16.6905%200.8125Z%27%20stroke%3D%27%23BAA57E%27%2F%3E%3Cpath%20d%3D%27M0.50592%206.78723L6.15048%2012.6473L6.42717%2012.3601L6.70386%2012.0728L1.05931%206.21271L0.782614%206.49997L0.50592%206.78723Z%27%20stroke%3D%27%23BAA57E%27%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%27clip0%27%3E%3Crect%20width%3D%2718%27%20height%3D%2713%27%20fill%3D%27white%27%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E')] checked:bg-no-repeat checked:bg-center",
  {
    variants: {
      size: {
        default: "w-[30px] h-[30px]",
        sm: "w-6 h-6 rounded",
        lg: "w-9 h-9 rounded-md"
      },
      error: {
        true: "border-status-error",
        false: "border-neutral-300"
      }
    },
    defaultVariants: {
      size: "default",
      error: false
    }
  }
);
var sizeAliases4 = {
  small: "sm",
  medium: "default",
  large: "lg"
};
var Checkbox = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    label,
    errorMsg,
    error,
    size,
    id,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    ...rest
  }, ref) => {
    const generatedId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    const checkboxId = id || generatedId;
    const hasError = !!errorMsg || error === true;
    const resolvedSize = typeof size === "string" && size in sizeAliases4 ? sizeAliases4[size] : size;
    const margins = resolveMargins({ mt, mb, ml, mr });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn("flex flex-col", margins.className, className),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              "input",
              {
                ref,
                id: checkboxId,
                type: "checkbox",
                className: cn(
                  checkboxVariants({ size: resolvedSize, error: hasError })
                ),
                "aria-invalid": hasError || void 0,
                ...rest
              }
            ),
            label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", { htmlFor: checkboxId, className: "cursor-pointer", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Small, { xs: true, children: label }) })
          ] }),
          errorMsg && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMessage, { children: errorMsg })
        ]
      }
    );
  }
);
Checkbox.displayName = "Checkbox";
function mergeRefs3(...refs) {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === "function") ref(value);
      else if (ref && typeof ref === "object")
        ref.current = value;
    }
  };
}
var Radio = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    errorMsg,
    error = false,
    inputRef,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    ...rest
  }, ref) => {
    const hasError = !!errorMsg || error;
    const margins = resolveMargins({ mt, mb, ml, mr });
    const mergedRef = mergeRefs3(ref, inputRef);
    const borderColor = hasError ? "border-status-error" : "border-neutral-300";
    const inputElement = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "input",
      {
        ref: mergedRef,
        type: "radio",
        className: cn(
          "relative appearance-none w-[30px] h-[30px] bg-white border rounded-full cursor-pointer shrink-0",
          "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:bg-neutral-100",
          borderColor,
          'checked:before:absolute checked:before:content-[""] checked:before:w-4 checked:before:h-4 checked:before:bg-neutral-700 checked:before:rounded-full checked:before:top-1/2 checked:before:right-1/2 checked:before:translate-x-1/2 checked:before:-translate-y-1/2',
          !errorMsg && margins.className,
          !errorMsg && className
        ),
        style: !errorMsg ? margins.style || style ? { ...margins.style, ...style } : void 0 : void 0,
        "aria-invalid": hasError || void 0,
        ...rest
      }
    );
    if (!errorMsg) return inputElement;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn(margins.className, className),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        children: [
          inputElement,
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMessage, { children: errorMsg })
        ]
      }
    );
  }
);
Radio.displayName = "Radio";
var RadioGroup = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    orientation,
    direction,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    children,
    ...rest
  }, ref) => {
    const resolvedOrientation = orientation ?? direction ?? "vertical";
    const margins = resolveMargins({ mt, mb, ml, mr });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "div",
      {
        ref,
        role: "radiogroup",
        className: cn(
          "flex gap-2",
          resolvedOrientation === "vertical" ? "flex-col" : "flex-row items-center",
          margins.className,
          className
        ),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        ...rest,
        children
      }
    );
  }
);
RadioGroup.displayName = "RadioGroup";
var Toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    onChange,
    checked,
    disabled = false,
    label,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    ...rest
  }, ref) => {
    const margins = resolveMargins({ mt, mb, ml, mr });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn(
          "inline-flex items-center gap-2",
          margins.className,
          className
        ),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", { className: "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              "input",
              {
                ref,
                type: "checkbox",
                checked: !!checked,
                disabled,
                onChange,
                className: "peer sr-only",
                ...rest
              }
            ),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              "span",
              {
                className: cn(
                  "absolute inset-0 rounded-full transition-colors",
                  "peer-checked:bg-neutral-900 peer-disabled:opacity-50",
                  !checked && "bg-neutral-200",
                  checked && "bg-neutral-900"
                )
              }
            ),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              "span",
              {
                className: cn(
                  "absolute left-0.5 h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform",
                  "peer-checked:translate-x-5"
                )
              }
            )
          ] }),
          label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", { className: "font-sans text-sm text-neutral-800 select-none", children: label })
        ]
      }
    );
  }
);
Toggle.displayName = "Toggle";
var textAreaVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "font-sans bg-white border box-border rounded-[5px] text-sm text-neutral-1000 px-3 py-2 w-full resize-y transition-colors focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-0 disabled:cursor-default disabled:bg-neutral-100",
  {
    variants: {
      size: {
        default: "min-h-[100px]",
        sm: "min-h-[60px] text-xs",
        lg: "min-h-[150px] text-base"
      },
      error: {
        true: "border-status-error",
        false: "border-neutral-300"
      }
    },
    defaultVariants: {
      size: "default",
      error: false
    }
  }
);
var TextArea = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({ size, error = false, className, ...props }, ref) => {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "textarea",
      {
        ref,
        className: cn(textAreaVariants({ size, error }), className),
        ...props
      }
    );
  }
);
TextArea.displayName = "TextArea";

// src/primitives/form/constants.ts
var FLOATING_LABEL_PLACEHOLDER = "\xA0";
var sizeAliases5 = {
  small: "sm",
  medium: "default",
  large: "lg"
};
var floatingLabelBodyClasses = "pointer-events-none absolute left-3.5 top-0 z-10 origin-left select-none text-inherit transition-transform duration-200 ease-[cubic-bezier(0,0,0.2,1)] whitespace-nowrap overflow-hidden text-ellipsis max-w-[calc(100%-3.5rem)] text-neutral-700 w-full translate-y-4 scale-100 peer-focus:translate-y-1 peer-focus:scale-[0.785] peer-[&:not(:placeholder-shown)]:translate-y-1 peer-[&:not(:placeholder-shown)]:scale-[0.785]";
var TextAreaField = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    label,
    floatingLabel = false,
    labelProps,
    errorMsg,
    error,
    size,
    width,
    mt,
    mb,
    ml,
    mr,
    className,
    style,
    ...textareaProps
  }, ref) => {
    const hasError = !!errorMsg || error === true;
    const resolvedSize = typeof size === "string" && size in sizeAliases5 ? sizeAliases5[size] : size;
    const generatedId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    const textareaId = textareaProps.id ?? generatedId;
    const { className: textareaClassName, ...restTextareaProps } = textareaProps;
    const margins = resolveMargins({ mt, mb, ml, mr });
    const isFloating = floatingLabel && !!label;
    const showStaticLabel = Boolean(label) && !isFloating;
    const sharedTextAreaProps = {
      ...restTextareaProps,
      ref,
      id: textareaId,
      size: resolvedSize,
      error: hasError,
      style: width === void 0 ? void 0 : { width },
      className: cn(textareaClassName, isFloating && "peer pt-6"),
      placeholder: isFloating ? FLOATING_LABEL_PLACEHOLDER : restTextareaProps.placeholder
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn("flex flex-col gap-1", margins.className, className),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        children: [
          showStaticLabel && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            Body,
            {
              as: "label",
              htmlFor: textareaId,
              weight: "demiBold",
              ...labelProps,
              children: label
            }
          ),
          isFloating ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "relative", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextArea, { ...sharedTextAreaProps }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
              Body,
              {
                ...labelProps,
                as: "label",
                htmlFor: textareaId,
                weight: "medium",
                className: cn(
                  floatingLabelBodyClasses,
                  { "text-xs": resolvedSize === "sm" || size === "small" },
                  labelProps?.className
                ),
                children: label
              }
            )
          ] }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextArea, { ...sharedTextAreaProps }),
          errorMsg && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMessage, { children: errorMsg })
        ]
      }
    );
  }
);
TextAreaField.displayName = "TextAreaField";
var Label = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({ mt, mb, ml, mr, className, style, children, ...rest }, ref) => {
    const margins = resolveMargins({ mt, mb, ml, mr });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      "label",
      {
        ref,
        className: cn(
          "font-sans text-sm font-semibold leading-none text-neutral-1000 peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
          margins.className,
          className
        ),
        style: margins.style || style ? { ...margins.style, ...style } : void 0,
        ...rest,
        children
      }
    );
  }
);
Label.displayName = "Label";
var VisaIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "12",
    viewBox: "0 0 34 12",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M14.8002 11.5763H12.127L13.799 0.206131H16.4721L14.8002 11.5763Z",
          fill: "#00579F"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M24.4906 0.48406C23.9634 0.254 23.1271 -1.52588e-05 22.093 -1.52588e-05C19.4531 -1.52588e-05 17.5941 1.54819 17.5827 3.76165C17.5607 5.39474 18.9136 6.3018 19.9255 6.84632C20.9598 7.40274 21.3113 7.76592 21.3113 8.26189C21.3008 9.02361 20.4756 9.37473 19.706 9.37473C18.6387 9.37473 18.0668 9.19371 17.1978 8.76992L16.8458 8.58825L16.4717 11.1406C17.0987 11.4548 18.2538 11.7335 19.4531 11.7458C22.258 11.7458 24.0841 10.2215 24.1057 7.8627C24.1164 6.56835 23.402 5.57657 21.8618 4.76614C20.9269 4.24589 20.3543 3.89509 20.3543 3.36279C20.3652 2.87887 20.8386 2.38322 21.894 2.38322C22.7631 2.35894 23.4016 2.58868 23.8853 2.81858L24.1271 2.93932L24.4906 0.48406Z",
          fill: "#00579F"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M28.0436 7.54828C28.2638 6.89508 29.1109 4.36699 29.1109 4.36699C29.0998 4.39126 29.3306 3.70173 29.4626 3.27842L29.6495 4.25815C29.6495 4.25815 30.1557 6.9798 30.2656 7.54828C29.8478 7.54828 28.5717 7.54828 28.0436 7.54828ZM31.3434 0.206131H29.2757C28.638 0.206131 28.1536 0.411593 27.8785 1.14952L23.9077 11.5762H26.7127C26.7127 11.5762 27.1744 10.1728 27.2737 9.87059C27.5814 9.87059 30.31 9.87059 30.7059 9.87059C30.7827 10.2698 31.0249 11.5762 31.0249 11.5762H33.5L31.3434 0.206131Z",
          fill: "#00579F"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M9.89392 0.206131L7.27594 7.95953L6.98987 6.38705C6.50586 4.57261 4.9879 2.60126 3.29395 1.62106L5.69192 11.5643H8.51878L12.7206 0.206131H9.89392Z",
          fill: "#00579F"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M4.84497 0.206131H0.544001L0.5 0.435869C3.85502 1.37942 6.07699 3.65382 6.9899 6.38753L6.05492 1.1619C5.90099 0.435709 5.42794 0.230086 4.84497 0.206131Z",
          fill: "#00579F"
        }
      )
    ]
  }
);
var MastercardIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.5371 26.1077H22.4607V9.89246H13.5371V26.1077Z",
          fill: "#FF5F00"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.1049 18C14.1049 14.7103 15.6281 11.7804 18.0001 9.89238C16.2653 8.51137 14.0766 7.68752 11.6975 7.68752C6.06547 7.68752 1.5 12.3046 1.5 18C1.5 23.6953 6.06547 28.3125 11.6975 28.3125C14.0766 28.3125 16.2653 27.4886 18.0001 26.1076C15.6281 24.2193 14.1049 21.2897 14.1049 18Z",
          fill: "#EB001B"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.1817 24.3903V23.9901H34.0783L33.9596 24.2654L33.8406 23.9901H33.7372V24.3903H33.81V24.0884L33.9216 24.3487H33.9973L34.1089 24.0878V24.3903H34.1817ZM33.527 24.3903V24.0583H33.6596V23.9907H33.3225V24.0583H33.4548V24.3903H33.527ZM34.5001 18C34.5001 23.6953 29.9344 28.3125 24.3026 28.3125C21.9235 28.3125 19.7346 27.4886 18 26.1076C20.372 24.2196 21.8952 21.2897 21.8952 18C21.8952 14.7106 20.372 11.7807 18 9.89238C19.7346 8.51137 21.9235 7.68752 24.3026 7.68752C29.9344 7.68752 34.5001 12.3046 34.5001 18Z",
          fill: "#F79E1B"
        }
      )
    ]
  }
);
var AmericanExpressIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "22",
    viewBox: "0 0 34 22",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", { x: "0.5", y: "0.500031", width: "33", height: "21", fill: "#016FD0" }),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M6.90768 17.4546V12.2723H12.3948L12.9835 13.0398L13.5917 12.2723H33.5085V17.0973C33.5085 17.0973 32.9877 17.4495 32.3853 17.4547H21.3569L20.6932 16.6377V17.4547H18.5181V16.0602C18.5181 16.0602 18.221 16.2548 17.5787 16.2548H16.8383V17.4547H13.5451L12.9573 16.6707L12.3604 17.4547L6.90768 17.4546ZM0.5 8.36644L1.73736 5.48169H3.87727L4.57945 7.09761V5.48169H7.23955L7.65758 6.64962L8.06284 5.48169H20.0039V6.06885C20.0039 6.06885 20.6316 5.48169 21.6632 5.48169L25.5377 5.49526L26.2277 7.09V5.48169H28.4539L29.0665 6.39774V5.48169H31.3131V10.664H29.0665L28.4794 9.74496V10.664H25.2087L24.8798 9.84708H24.0006L23.677 10.664H21.459C20.5713 10.664 20.0039 10.0888 20.0039 10.0888V10.664H16.6596L15.9959 9.84711V10.664H3.56026L3.23157 9.84711H2.35506L2.02879 10.664H0.5V8.36644Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M2.17528 6.12029L0.506348 10.0006H1.59291L1.90086 9.2236H3.69106L3.99738 10.0006H5.10791L3.4405 6.12029H2.17528ZM2.79275 7.02334L3.33841 8.38118H2.24549L2.79275 7.02334ZM5.22276 9.99998V6.11963L6.76681 6.12535L7.66489 8.62718L8.54146 6.11963H10.0732V9.99998H9.10311V7.14077L8.07478 9.99998H7.22402L6.19285 7.14077V9.99998H5.22276ZM10.7369 9.99998V6.11963H13.9025V6.9876H11.7172V7.65133H13.8514V8.46827H11.7172V9.15755H13.9025V9.99998H10.7369ZM14.4641 6.12029V10.0006H15.4342V8.62208H15.8427L17.0058 10.0006H18.1913L16.9149 8.57102C17.4387 8.52681 17.9791 8.07721 17.9791 7.37916C17.9791 6.56261 17.3382 6.12029 16.6229 6.12029H14.4641ZM15.4342 6.98826H16.5431C16.8091 6.98826 17.0026 7.19633 17.0026 7.3967C17.0026 7.65448 16.7519 7.80517 16.5575 7.80517H15.4342V6.98826ZM19.3656 9.99998H18.3751V6.11963H19.3656V9.99998ZM21.7142 9.99998H21.5005C20.466 9.99998 19.8379 9.18495 19.8379 8.07575C19.8379 6.93912 20.4589 6.11963 21.7653 6.11963H22.8375V7.03866H21.7261C21.1958 7.03866 20.8208 7.45252 20.8208 8.08532C20.8208 8.83681 21.2496 9.15242 21.8674 9.15242H22.1227L21.7142 9.99998ZM23.8252 6.12029L22.1562 10.0006H23.2428L23.5507 9.2236H25.3409L25.6473 10.0006H26.7578L25.0904 6.12029H23.8252ZM24.4426 7.02334L24.9883 8.38118H23.8953L24.4426 7.02334ZM26.871 9.99998V6.11963H28.1044L29.6792 8.55762V6.11963H30.6493V9.99998H29.4558L27.8411 7.49819V9.99998H26.871ZM7.57141 16.7906V12.9102H10.7369V13.7782H8.55169V14.442H10.6859V15.2589H8.55169V15.9482H10.7369V16.7906H7.57141ZM23.0826 16.7906V12.9102H26.2481V13.7782H24.0629V14.442H26.1869V15.2589H24.0628V15.9482H26.2481V16.7906H23.0826ZM10.8598 16.7906L12.4011 14.8744L10.8231 12.9102H12.0453L12.9851 14.1244L13.9281 12.9102H15.1024L13.5451 14.8504L15.0892 16.7906H13.8673L12.9548 15.5955L12.0645 16.7906H10.8598ZM15.2045 12.9109V16.7912H16.2001V15.5659H17.2212C18.0852 15.5659 18.7402 15.1075 18.7402 14.2161C18.7402 13.4776 18.2265 12.9109 17.3473 12.9109H15.2045ZM16.2001 13.7885H17.2755C17.5546 13.7885 17.7541 13.9595 17.7541 14.2352C17.7541 14.4942 17.5556 14.6819 17.2723 14.6819H16.2001V13.7885ZM19.1614 12.9102V16.7906H20.1315V15.412H20.5399L21.7031 16.7906H22.8886L21.6122 15.361C22.136 15.3168 22.6763 14.8672 22.6763 14.1691C22.6763 13.3526 22.0354 12.9102 21.3202 12.9102H19.1614ZM20.1315 13.7782H21.2404C21.5064 13.7782 21.6999 13.9863 21.6999 14.1867C21.6999 14.4445 21.4492 14.5951 21.2547 14.5951H20.1315V13.7782ZM26.6974 16.7906V15.9482H28.6389C28.9262 15.9482 29.0505 15.7929 29.0505 15.6226C29.0505 15.4595 28.9265 15.2946 28.6389 15.2946H27.7616C26.999 15.2946 26.5743 14.83 26.5743 14.1324C26.5743 13.5102 26.9632 12.9102 28.0964 12.9102H29.9855L29.5771 13.7833H27.9432C27.6309 13.7833 27.5348 13.9472 27.5348 14.1037C27.5348 14.2645 27.6536 14.442 27.8922 14.442H28.8112C29.6613 14.442 30.0302 14.9242 30.0302 15.5556C30.0302 16.2346 29.6191 16.7906 28.7649 16.7906H26.6974ZM30.2579 16.7906V15.9482H32.1993C32.4866 15.9482 32.611 15.7929 32.611 15.6226C32.611 15.4595 32.487 15.2946 32.1993 15.2946H31.322C30.5594 15.2946 30.1347 14.83 30.1347 14.1324C30.1347 13.5102 30.5236 12.9102 31.6569 12.9102H33.546L33.1375 13.7833H31.5037C31.1914 13.7833 31.0952 13.9472 31.0952 14.1037C31.0952 14.2645 31.214 14.442 31.4526 14.442H32.3717C33.2218 14.442 33.5906 14.9242 33.5906 15.5556C33.5906 16.2346 33.1796 16.7906 32.3254 16.7906H30.2579Z",
          fill: "#016FD0"
        }
      )
    ]
  }
);
var DiscoverIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M1.8623 8.58682V27.5177C1.8623 27.9172 2.18734 28.2422 2.58685 28.2422H22.6864C28.3142 28.2422 32.8764 23.68 32.8764 18.0523C32.8764 12.4245 28.3142 7.86228 22.6864 7.86228H2.58685C2.18734 7.86228 1.8623 8.18732 1.8623 8.58682Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M4.31191 15.7624H3.02783V20.2471H4.30501C4.98416 20.2471 5.47474 20.0871 5.90517 19.7293C6.41674 19.3058 6.71926 18.6677 6.71926 18.0079C6.71926 16.6844 5.73046 15.7624 4.31191 15.7624ZM5.33365 19.1315C5.05879 19.3795 4.70174 19.4878 4.13669 19.4878H3.90181V16.5224H4.13669C4.70174 16.5224 5.04469 16.6233 5.33365 16.8851C5.63631 17.1544 5.81799 17.5717 5.81799 18.0013C5.81799 18.4318 5.63631 18.8623 5.33365 19.1315Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { d: "M7.9967 15.7624H7.12207V20.2471H7.9967V15.7624Z", fill: "black" }),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M10.1351 17.4833C9.61018 17.289 9.45602 17.1609 9.45602 16.9187C9.45602 16.6362 9.73067 16.4215 10.1076 16.4215C10.3698 16.4215 10.5851 16.5293 10.8131 16.7849L11.2709 16.1855C10.8946 15.8565 10.4446 15.6882 9.95307 15.6882C9.15959 15.6882 8.55432 16.2394 8.55432 16.9732C8.55432 17.5911 8.83622 17.9073 9.65773 18.2031C10 18.3238 10.1743 18.4044 10.2623 18.4584C10.437 18.5723 10.5247 18.734 10.5247 18.9224C10.5247 19.2858 10.2357 19.5549 9.84535 19.5549C9.42837 19.5549 9.09216 19.3466 8.89074 18.9571L8.32568 19.5009C8.72865 20.0926 9.21263 20.3547 9.87822 20.3547C10.7874 20.3547 11.4251 19.7504 11.4251 18.8825C11.4251 18.1696 11.1303 17.8473 10.1351 17.4833Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M11.7012 18.0079C11.7012 19.326 12.7363 20.348 14.0683 20.348C14.4448 20.348 14.7671 20.274 15.1649 20.0871V19.0572C14.8151 19.407 14.5053 19.5482 14.1088 19.5482C13.2278 19.5482 12.6025 18.9095 12.6025 18.0013C12.6025 17.1404 13.2478 16.4612 14.0683 16.4612C14.4854 16.4612 14.8015 16.6099 15.1649 16.9657V15.9365C14.781 15.7418 14.4653 15.6612 14.0889 15.6612C12.7637 15.6612 11.7012 16.7039 11.7012 18.0079Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M22.1009 18.7746L20.9046 15.7624H19.9492L21.8523 20.3624H22.3231L24.2604 15.7624H23.3121L22.1009 18.7746Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M24.6558 20.2471H27.1367V19.4878H25.5301V18.2772H27.0771V17.5176H25.5301V16.5224H27.1367V15.7624H24.6558V20.2471Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M30.6008 17.0863C30.6008 16.2469 30.022 15.7624 29.0133 15.7624H27.7163V20.2471H28.5898V18.4455H28.7042L29.9149 20.2471H30.9906L29.5786 18.3578C30.2378 18.2238 30.6008 17.7732 30.6008 17.0863ZM28.8457 17.8271H28.5898V16.4688H28.8592C29.4042 16.4688 29.7004 16.697 29.7004 17.1335C29.7004 17.5844 29.4042 17.8271 28.8457 17.8271Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M31.2978 15.9976C31.2978 15.9188 31.2432 15.8757 31.1478 15.8757H31.021V16.2711H31.1152V16.1177L31.2259 16.2711H31.3412L31.2112 16.108C31.2667 16.0931 31.2978 16.0525 31.2978 15.9976ZM31.1314 16.0516H31.1152V15.9482H31.1322C31.1789 15.9482 31.2033 15.965 31.2033 15.999C31.2033 16.034 31.1786 16.0516 31.1314 16.0516Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M31.1668 15.7278C30.9749 15.7278 30.8223 15.881 30.8223 16.0725C30.8223 16.264 30.9766 16.4174 31.1668 16.4174C31.3538 16.4174 31.5073 16.2622 31.5073 16.0725C31.5073 15.8837 31.3538 15.7278 31.1668 15.7278ZM31.1654 16.3558C31.0142 16.3558 30.8907 16.23 30.8907 16.073C30.8907 15.9155 31.013 15.7898 31.1654 15.7898C31.3159 15.7898 31.4383 15.9184 31.4383 16.073C31.4383 16.2286 31.3159 16.3558 31.1654 16.3558Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M20.1983 17.9999C20.1983 19.3114 19.1352 20.3746 17.8236 20.3746C16.5119 20.3746 15.4487 19.3114 15.4487 17.9999C15.4487 16.6882 16.5119 15.625 17.8236 15.625C19.1352 15.625 20.1983 16.6882 20.1983 17.9999Z",
          fill: "#F37321"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M33.4132 7.49998H2.58681C1.98658 7.49998 1.5 7.98657 1.5 8.5868V27.5176C1.5 28.1179 1.98658 28.6045 2.58681 28.6045H33.4132C34.0134 28.6045 34.5 28.1179 34.5 27.5176V8.5868C34.5 7.98657 34.0134 7.49998 33.4132 7.49998ZM32.8763 18.0522C32.8763 23.68 28.3141 28.2422 22.6864 28.2422H2.58681C2.18729 28.2422 1.86227 27.9172 1.86227 27.5176V8.5868C1.86227 8.18729 2.18729 7.86226 2.58681 7.86226H22.6864C28.3141 7.86226 32.8763 12.4245 32.8763 18.0522Z",
          fill: "#F37321"
        }
      )
    ]
  }
);
var JcbIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "28",
    viewBox: "0 0 34 28",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M25.3579 16.8208H27.7394C27.8074 16.8208 27.9662 16.7968 28.0342 16.7968C28.4878 16.7008 28.8734 16.2687 28.8734 15.6685C28.8734 15.0923 28.4878 14.6602 28.0342 14.5402C27.9662 14.5161 27.8301 14.5161 27.7394 14.5161H25.3579V16.8208Z",
          fill: "url(#le-jcb-paint0_linear_7651_31)"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M27.4669 0.904041C25.1989 0.904041 23.3391 2.84863 23.3391 5.27336V9.81072H29.168C29.304 9.81072 29.4628 9.81072 29.5762 9.83473C30.8917 9.90675 31.8669 10.627 31.8669 11.8753C31.8669 12.8596 31.2092 13.6999 29.9845 13.8679V13.916C31.3226 14.012 32.3432 14.8042 32.3432 16.0286C32.3432 17.349 31.2092 18.2132 29.7123 18.2132H23.3164V27.0959H29.3721C31.6401 27.0959 33.4999 25.1513 33.4999 22.7266V0.904041H27.4669Z",
          fill: "url(#le-jcb-paint1_linear_7651_31)"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M28.5785 12.1635C28.5785 11.5873 28.193 11.2032 27.7394 11.1312C27.694 11.1312 27.5806 11.1072 27.5126 11.1072H25.3579V13.2198H27.5126C27.5806 13.2198 27.7167 13.2198 27.7394 13.1958C28.193 13.1238 28.5785 12.7397 28.5785 12.1635Z",
          fill: "url(#le-jcb-paint2_linear_7651_31)"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M4.65052 0.904041C2.38247 0.904041 0.52268 2.85041 0.52268 5.27736V16.0665C1.67938 16.6672 2.88144 17.0517 4.08351 17.0517C5.51237 17.0517 6.28351 16.1386 6.28351 14.8891V9.79486H9.82165V14.865C9.82165 16.8354 8.66495 18.4454 4.74124 18.4454C2.35979 18.4454 0.5 17.8927 0.5 17.8927V27.0959H6.55567C8.82371 27.0959 10.6835 25.1495 10.6835 22.7226V0.904041H4.65052Z",
          fill: "url(#le-jcb-paint3_linear_7651_31)"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M16.0585 0.904041C13.7905 0.904041 11.9307 2.84685 11.9307 5.26935V10.9778C12.974 10.0424 14.7884 9.44278 17.7142 9.58669C19.2791 9.65865 20.9575 10.1144 20.9575 10.1144V11.9612C20.1183 11.5055 19.1204 11.0978 17.8276 11.0018C15.6049 10.8339 14.2667 11.9852 14.2667 14C14.2667 16.0387 15.6049 17.19 17.8276 16.9981C19.1204 16.9022 20.1183 16.4705 20.9575 16.0387V17.8856C20.9575 17.8856 19.3018 18.3413 17.7142 18.4133C14.7884 18.5572 12.974 17.9575 11.9307 17.0221V27.0959H17.9863C20.2544 27.0959 22.1142 25.1531 22.1142 22.7306V0.904041H16.0585Z",
          fill: "url(#le-jcb-paint4_linear_7651_31)"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("defs", { children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
          "linearGradient",
          {
            id: "le-jcb-paint0_linear_7651_31",
            x1: "23.3273",
            y1: "15.6765",
            x2: "33.5206",
            y2: "15.6765",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { stopColor: "#007940" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.2285", stopColor: "#00873F" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.7433", stopColor: "#40A737" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "1", stopColor: "#5CB531" })
            ]
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
          "linearGradient",
          {
            id: "le-jcb-paint1_linear_7651_31",
            x1: "23.3274",
            y1: "14.008",
            x2: "33.5109",
            y2: "14.008",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { stopColor: "#007940" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.2285", stopColor: "#00873F" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.7433", stopColor: "#40A737" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "1", stopColor: "#5CB531" })
            ]
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
          "linearGradient",
          {
            id: "le-jcb-paint2_linear_7651_31",
            x1: "23.3273",
            y1: "12.1715",
            x2: "33.5197",
            y2: "12.1715",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { stopColor: "#007940" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.2285", stopColor: "#00873F" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.7433", stopColor: "#40A737" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "1", stopColor: "#5CB531" })
            ]
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
          "linearGradient",
          {
            id: "le-jcb-paint3_linear_7651_31",
            x1: "0.50996",
            y1: "14.008",
            x2: "10.86",
            y2: "14.008",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { stopColor: "#1F286F" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.4751", stopColor: "#004E94" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.8261", stopColor: "#0066B1" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "1", stopColor: "#006FBC" })
            ]
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
          "linearGradient",
          {
            id: "le-jcb-paint4_linear_7651_31",
            x1: "11.8642",
            y1: "14.008",
            x2: "21.916",
            y2: "14.008",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { stopColor: "#6C2C2F" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.1735", stopColor: "#882730" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.5731", stopColor: "#BE1833" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "0.8585", stopColor: "#DC0436" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", { offset: "1", stopColor: "#E60039" })
            ]
          }
        )
      ] })
    ]
  }
);
var UnionPayIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "24",
    viewBox: "0 0 34 24",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M6.96272 0.522179H15.1996C16.3493 0.522179 17.0645 1.56435 16.7963 2.8472L12.9614 21.1562C12.6908 22.4346 11.5396 23.4777 10.389 23.4777H2.15296C1.00478 23.4777 0.288042 22.4346 0.556266 21.1562L4.39271 2.8472C4.66093 1.56435 5.81153 0.522179 6.96272 0.522179Z",
          fill: "#E21836"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M14.514 0.521713H23.9861C25.1357 0.521713 24.6173 1.56389 24.3469 2.84673L20.5127 21.1558C20.2436 22.4341 20.3276 23.4772 19.1756 23.4772H9.7034C8.5514 23.4772 7.83848 22.4341 8.10911 21.1558L11.9431 2.84673C12.2154 1.56389 13.3636 0.521713 14.514 0.521713Z",
          fill: "#00447C"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M23.6098 0.521713H31.8466C32.998 0.521713 33.7131 1.56389 33.4427 2.84673L29.6085 21.1558C29.3378 22.4341 28.1858 23.4772 27.0346 23.4772H18.8016C17.6496 23.4772 16.9351 22.4341 17.2049 21.1558L21.0398 2.84673C21.308 1.56389 22.4578 0.521713 23.6098 0.521713Z",
          fill: "#007B84"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M9.11365 6.38933C8.26661 6.39893 8.01646 6.38933 7.93655 6.36834C7.90584 6.53065 7.33425 9.46271 7.33265 9.46517C7.20958 10.0584 7.12004 10.4812 6.81588 10.7543C6.64322 10.913 6.44165 10.9896 6.20795 10.9896C5.83232 10.9896 5.61349 10.7822 5.57675 10.3888L5.56972 10.2537C5.56972 10.2537 5.68416 9.45914 5.68416 9.45468C5.68416 9.45468 6.28405 6.78271 6.39146 6.42952C6.39708 6.40942 6.39868 6.39893 6.40009 6.38933C5.23243 6.40072 5.02544 6.38933 5.01119 6.36834C5.00336 6.39714 4.97445 6.5628 4.97445 6.5628L4.36191 9.57434L4.30931 9.82975L4.20752 10.6652C4.20752 10.913 4.25129 11.1153 4.33842 11.2863C4.61748 11.8286 5.41352 11.9099 5.86384 11.9099C6.44406 11.9099 6.98833 11.7728 7.35614 11.5225C7.99457 11.103 8.16161 10.4473 8.31058 9.86458L8.37964 9.56564C8.37964 9.56564 8.9976 6.79053 9.1026 6.42952C9.10662 6.40942 9.10823 6.39893 9.11365 6.38933ZM11.2162 8.62804C11.0672 8.62804 10.795 8.66822 10.5505 8.80151C10.4617 8.85219 10.3778 8.91068 10.2893 8.96895L10.3692 8.64813L10.3254 8.5941C9.80683 8.71087 9.69079 8.7265 9.21176 8.80151L9.17161 8.8312C9.116 9.34403 9.06661 9.7296 8.86042 10.7376C8.78192 11.1091 8.70041 11.4842 8.6187 11.8548L8.64078 11.9019C9.13166 11.8731 9.28062 11.8731 9.70725 11.8809L9.74178 11.8392C9.79599 11.5304 9.80302 11.4581 9.92308 10.8327C9.97949 10.5362 10.0971 9.88476 10.1552 9.6528C10.2618 9.59788 10.367 9.54385 10.4674 9.54385C10.7065 9.54385 10.6774 9.77581 10.6681 9.86824C10.6579 10.0234 10.5707 10.5302 10.4814 10.9653L10.4218 11.2462C10.3802 11.4536 10.3346 11.6552 10.2931 11.8608L10.3112 11.9019C10.795 11.8731 10.9426 11.8731 11.3557 11.8809L11.4043 11.8392C11.479 11.3569 11.5009 11.2279 11.6334 10.5257L11.7001 10.2031C11.8296 9.57175 11.8946 9.2516 11.7966 8.99083C11.693 8.69859 11.4445 8.62804 11.2162 8.62804ZM13.565 9.28909C13.3078 9.34401 13.1438 9.38062 12.9808 9.40429C12.8192 9.43309 12.6616 9.45921 12.413 9.49761L12.3933 9.51748L12.3753 9.53333C12.3494 9.73918 12.3313 9.91711 12.297 10.1263C12.2679 10.3426 12.2231 10.5885 12.1502 10.9416C12.0938 11.212 12.0647 11.3062 12.0326 11.4013C12.0012 11.4964 11.9667 11.5889 11.9033 11.8548L11.9181 11.8793L11.9306 11.9019C12.1629 11.8896 12.3148 11.8809 12.471 11.8793C12.627 11.8731 12.7887 11.8793 13.0388 11.8809L13.0607 11.861L13.0842 11.8392C13.1203 11.5994 13.1257 11.5349 13.1478 11.4179C13.1697 11.2924 13.2075 11.1187 13.3 10.6548C13.3438 10.4369 13.3926 10.2196 13.4379 9.99726C13.4851 9.77579 13.5345 9.55767 13.5815 9.33977L13.5745 9.31342L13.565 9.28909ZM13.5705 8.39779C13.3368 8.24441 12.9266 8.29308 12.6506 8.50496C12.3753 8.71259 12.344 9.00729 12.5769 9.16268C12.8066 9.31181 13.2184 9.26739 13.492 9.05373C13.7666 8.84163 13.801 8.54961 13.5705 8.39779ZM14.9838 11.95C15.4566 11.95 15.9412 11.8051 16.306 11.3751C16.5867 11.0263 16.7154 10.5075 16.76 10.2938C16.9051 9.58564 16.7921 9.25499 16.6502 9.05362C16.4345 8.74663 16.0535 8.64818 15.6582 8.64818C15.4205 8.64818 14.8543 8.6743 14.412 9.12774C14.0944 9.45481 13.9476 9.89865 13.8591 10.3242C13.7698 10.7578 13.667 11.5383 14.3124 11.8287C14.5116 11.9238 14.7987 11.95 14.9838 11.95ZM14.9469 10.3566C15.0559 9.82029 15.1846 9.3702 15.513 9.3702C15.7704 9.3702 15.7891 9.70508 15.6746 10.2431C15.6542 10.3626 15.5602 10.8066 15.4331 10.9957C15.3444 11.1353 15.2394 11.2199 15.1233 11.2199C15.0888 11.2199 14.8834 11.2199 14.8802 10.8808C14.8786 10.7133 14.9093 10.5423 14.9469 10.3566ZM17.9419 11.881L17.9788 11.8392C18.0312 11.5305 18.0399 11.4579 18.1559 10.8328C18.2139 10.5363 18.334 9.88483 18.3904 9.65286C18.4972 9.59772 18.6006 9.54369 18.7042 9.54369C18.9417 9.54369 18.9128 9.77566 18.9034 9.86809C18.8947 10.0235 18.8076 10.5301 18.7166 10.9652L18.6602 11.246C18.6171 11.4537 18.5701 11.6551 18.5285 11.8609L18.5466 11.902C19.032 11.8732 19.174 11.8732 19.5896 11.881L19.6398 11.8392C19.7126 11.3568 19.7323 11.2277 19.8688 10.5258L19.9339 10.203C20.064 9.5716 20.1298 9.25167 20.0335 8.9909C19.9269 8.69865 19.6767 8.62811 19.4516 8.62811C19.3025 8.62811 19.0288 8.66807 18.7857 8.80158C18.6988 8.85226 18.6116 8.91053 18.5261 8.96902L18.6006 8.6482L18.5606 8.59395C18.0423 8.71093 17.9238 8.72656 17.4454 8.80158L17.4086 8.83127C17.3506 9.3441 17.3034 9.72944 17.0973 10.7377C17.0188 11.1092 16.9372 11.4843 16.8557 11.8549L16.8776 11.902C17.3693 11.8732 17.5161 11.8732 17.9419 11.881ZM21.5086 11.9019C21.5391 11.7362 21.7204 10.7543 21.722 10.7543C21.722 10.7543 21.8764 10.0339 21.8858 10.0077C21.8858 10.0077 21.9344 9.93272 21.983 9.90303H22.0545C22.7289 9.90303 23.4904 9.90303 24.0872 9.41476C24.4934 9.07987 24.7711 8.58535 24.8949 7.98434C24.927 7.83699 24.9507 7.66173 24.9507 7.48647C24.9507 7.25629 24.9092 7.02857 24.7891 6.85063C24.4848 6.3771 23.8786 6.36839 23.179 6.36482C23.1768 6.36482 22.8341 6.36839 22.8341 6.36839C21.9384 6.38067 21.5793 6.3771 21.4317 6.357C21.4193 6.42956 21.3958 6.55861 21.3958 6.55861C21.3958 6.55861 21.0749 8.21206 21.0749 8.21474C21.0749 8.21474 20.3072 11.7302 20.2711 11.8958C21.0531 11.8853 21.3737 11.8853 21.5086 11.9019ZM22.1031 8.96467C22.1031 8.96467 22.4442 7.31456 22.4426 7.32081L22.4536 7.2362L22.4584 7.17167L22.5947 7.1873C22.5947 7.1873 23.2982 7.2545 23.3147 7.25629C23.5924 7.37573 23.7068 7.68361 23.6269 8.08547C23.554 8.45274 23.3398 8.7615 23.0645 8.91064C22.8379 9.037 22.5602 9.0475 22.2741 9.0475H22.089L22.1031 8.96467ZM24.2269 10.3871C24.1367 10.8144 24.0331 11.595 24.6754 11.8731C24.8801 11.97 25.0637 11.9988 25.2502 11.9883C25.4471 11.9765 25.6296 11.8667 25.7987 11.7086C25.7834 11.7736 25.7681 11.8385 25.7529 11.9037L25.782 11.9455C26.244 11.9238 26.3873 11.9238 26.8878 11.9281L26.9332 11.8897C27.0063 11.4119 27.0751 10.9479 27.2651 10.0339C27.3576 9.59611 27.45 9.16254 27.5449 8.72652L27.5301 8.67852C27.0133 8.78501 26.8752 8.80778 26.3781 8.88615L26.3403 8.92031C26.3353 8.96474 26.3301 9.00738 26.3253 9.05002C26.248 8.91115 26.1359 8.7926 25.9631 8.7187C25.742 8.62203 25.2229 8.74661 24.7766 9.19849C24.463 9.5211 24.3124 9.96315 24.2269 10.3871ZM25.3122 10.4132C25.4228 9.88657 25.5499 9.44095 25.8792 9.44095C26.0874 9.44095 26.197 9.65461 26.1747 10.019C26.157 10.1098 26.1379 10.2056 26.1153 10.3139C26.0823 10.4704 26.0466 10.6256 26.0119 10.7809C25.9765 10.8872 25.9354 10.9875 25.8902 11.0542C25.8055 11.1877 25.6039 11.2706 25.4879 11.2706C25.4549 11.2706 25.2518 11.2706 25.2447 10.9375C25.2431 10.7716 25.2739 10.6008 25.3122 10.4132ZM30.9799 8.67425L30.94 8.62357C30.4286 8.73878 30.3361 8.75708 29.8663 8.82763L29.8317 8.86603C29.8301 8.87228 29.8287 8.88188 29.8263 8.89059L29.8247 8.88188C29.475 9.77916 29.4852 9.5856 29.2005 10.292C29.1989 10.2598 29.1989 10.2397 29.1973 10.2056L29.1261 8.67425L29.0813 8.62357C28.5456 8.73878 28.533 8.75708 28.0383 8.82763L27.9998 8.86603C27.9943 8.88434 27.9943 8.90443 27.9911 8.92631L27.9943 8.93413C28.0562 9.28554 28.0413 9.20717 28.1034 9.76175C28.1323 10.0339 28.1708 10.3076 28.1997 10.5764C28.2485 11.0263 28.2758 11.2478 28.3354 11.9343C28.0014 12.5474 27.9223 12.7793 27.6006 13.3174L27.6028 13.3227L27.3764 13.721C27.3505 13.763 27.327 13.7918 27.2941 13.8041C27.2579 13.8239 27.2109 13.8275 27.1457 13.8275H27.0202L26.8337 14.5174L27.4735 14.5297C27.8492 14.5279 28.0853 14.3325 28.2124 14.07L28.6147 13.3033H28.6083L28.6506 13.2493C28.9213 12.6014 30.9799 8.67425 30.9799 8.67425ZM24.2268 17.7347H23.9554L24.96 14.0395H25.2933L25.3991 13.6588L25.4093 14.0821C25.3969 14.3438 25.582 14.5758 26.0683 14.5374H26.6306L26.8241 13.8258H26.6125C26.4909 13.8258 26.4345 13.7917 26.4415 13.7185L26.4312 13.2878H25.3899V13.29C25.0532 13.2978 24.0478 13.326 23.8442 13.3862C23.5978 13.4568 23.3382 13.6644 23.3382 13.6644L23.4402 13.2833H22.4661L22.2631 14.0395L21.2451 17.7911H21.0475L20.8538 18.4975H22.794L22.7289 18.7331H23.685L23.7484 18.4975H24.0166L24.2268 17.7347ZM23.4308 14.7903C23.2748 14.8383 22.9845 14.9839 22.9845 14.9839L23.2427 14.0395H24.0166L23.8299 14.7276C23.8299 14.7276 23.5908 14.7432 23.4308 14.7903ZM23.4457 16.1395C23.4457 16.1395 23.2025 16.1734 23.0425 16.2136C22.8849 16.2667 22.5894 16.4342 22.5894 16.4342L22.856 15.4514H23.634L23.4457 16.1395ZM23.012 17.7434H22.2356L22.4607 16.914H23.2346L23.012 17.7434ZM24.8817 15.4514H26.0007L25.8399 16.0305H24.706L24.5357 16.6637H25.5279L24.7767 17.84C24.7241 17.9264 24.6769 17.957 24.6245 17.9814C24.5719 18.0111 24.5028 18.0459 24.4229 18.0459H24.1477L23.9585 18.7393H24.6785C25.0527 18.7393 25.2738 18.55 25.437 18.3015L25.9521 17.5174L26.0628 18.3136C26.0863 18.4627 26.1826 18.55 26.2479 18.5839C26.3199 18.6241 26.3944 18.6931 26.4996 18.7034C26.6125 18.7087 26.694 18.713 26.7482 18.713H27.1019L27.3143 17.9369H27.1748C27.0947 17.9369 26.9568 17.922 26.9333 17.8941C26.9098 17.8601 26.9098 17.8079 26.8971 17.7284L26.7849 16.9305H26.3254L26.5269 16.6637H27.6587L27.8327 16.0305H26.7849L26.9481 15.4514H27.9927L28.1865 14.7372H25.0722L24.8817 15.4514ZM15.4299 17.9046L15.6911 16.9384H16.7646L16.9608 16.2197H15.8863L16.0503 15.6249H17.1003L17.2949 14.929H14.6676L14.4771 15.6249H15.074L14.9148 16.2197H14.3163L14.1179 16.9506H14.7146L14.3665 18.229C14.3195 18.3983 14.3886 18.4628 14.4323 18.5414C14.4771 18.6179 14.5225 18.6686 14.6245 18.6974C14.7297 18.7235 14.8017 18.7392 14.8997 18.7392H16.1099L16.3256 17.943L15.7891 18.025C15.6855 18.025 15.3986 18.0111 15.4299 17.9046ZM15.5531 13.279L15.281 13.8257C15.2228 13.9452 15.1704 14.0193 15.1232 14.0535C15.0817 14.0823 14.9994 14.0943 14.8801 14.0943H14.7382L14.5484 14.7938H15.0198C15.2465 14.7938 15.4206 14.7014 15.5037 14.6551C15.593 14.602 15.6165 14.6324 15.6856 14.5582L15.8448 14.4049H17.3168L17.5121 13.6766H16.4346L16.6227 13.279H15.5531ZM17.7262 17.9187C17.7011 17.8785 17.7192 17.8077 17.7576 17.6604L18.1599 16.1795H19.5912C19.7998 16.1761 19.9503 16.1735 20.0483 16.1656C20.1535 16.1534 20.2679 16.1116 20.3926 16.0366C20.5213 15.958 20.5872 15.8752 20.6428 15.7801C20.7048 15.6852 20.8044 15.4776 20.8899 15.1574L21.3956 13.2834L19.9104 13.293C19.9104 13.293 19.453 13.368 19.2517 13.4508C19.0485 13.5432 18.7582 13.8013 18.7582 13.8013L18.8923 13.2876H17.9748L16.6903 18.0249C16.6447 18.2089 16.6142 18.3424 16.6072 18.4226C16.6048 18.509 16.7051 18.5945 16.7702 18.659C16.8471 18.7235 16.9607 18.713 17.0697 18.7235C17.1844 18.7331 17.3474 18.7392 17.5725 18.7392H18.2775L18.494 17.9265L17.8628 17.9928C17.7953 17.9928 17.7465 17.9526 17.7262 17.9187ZM18.4195 15.1793H19.9228L19.8273 15.5124C19.8138 15.5202 19.7817 15.4959 19.6287 15.516H18.3269L18.4195 15.1793ZM18.7206 14.0621H20.2366L20.1276 14.4633C20.1276 14.4633 19.4131 14.4555 19.2986 14.4789C18.7951 14.5758 18.501 14.875 18.501 14.875L18.7206 14.0621ZM19.8609 16.6279C19.8485 16.6776 19.8288 16.708 19.8013 16.7308C19.7708 16.7527 19.7214 16.7605 19.6477 16.7605H19.4335L19.4461 16.3548H18.5551L18.519 18.338C18.5176 18.4811 18.53 18.564 18.6242 18.6303C18.7183 18.7131 19.0085 18.7236 19.3989 18.7236H19.9573L20.1588 17.9813L19.6728 18.0109L19.5112 18.0214C19.4891 18.011 19.468 18.0013 19.4445 17.9752C19.424 17.9527 19.3895 17.9665 19.3951 17.8234L19.3989 17.3151L19.9087 17.2916C20.1839 17.2916 20.3016 17.192 20.402 17.0971C20.4977 17.0063 20.5291 16.9018 20.5652 16.7605L20.6507 16.3104H19.9503L19.8609 16.6279Z",
          fill: "#FEFEFE"
        }
      )
    ]
  }
);
var DinersClubIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "24",
    viewBox: "0 0 34 24",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.32498 14.6868C3.32498 14.1449 3.04185 14.1805 2.771 14.1748V14.0181C3.00584 14.0295 3.24665 14.0295 3.48212 14.0295C3.73509 14.0295 4.07855 14.0181 4.52475 14.0181C6.0853 14.0181 6.93534 15.0601 6.93534 16.1273C6.93534 16.7244 6.58576 18.2246 4.45228 18.2246C4.14519 18.2246 3.86158 18.2127 3.57845 18.2127C3.30747 18.2127 3.04185 18.2183 2.771 18.2246V18.0678C3.1322 18.0314 3.30747 18.0196 3.32498 17.6099V14.6868ZM3.91557 17.5131C3.91557 17.9773 4.24737 18.0314 4.54251 18.0314C5.8446 18.0314 6.2719 17.0493 6.2719 16.1514C6.2719 15.0246 5.54883 14.2111 4.38589 14.2111C4.13828 14.2111 4.02431 14.2287 3.91557 14.2352V17.5131Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.14648 18.0679H7.26069C7.4294 18.0679 7.55002 18.0679 7.55002 17.8686V16.2356C7.55002 15.9709 7.4598 15.9342 7.23651 15.814V15.7179C7.51976 15.6327 7.85753 15.519 7.88137 15.5009C7.92378 15.4767 7.95943 15.4703 7.99011 15.4703C8.01961 15.4703 8.03204 15.5065 8.03204 15.5552V17.8686C8.03204 18.0679 8.16483 18.0679 8.33382 18.0679H8.43579V18.2247C8.23088 18.2247 8.01961 18.2128 7.80337 18.2128C7.58643 18.2128 7.36929 18.2184 7.14648 18.2247V18.0679ZM7.79121 14.5425C7.63424 14.5425 7.49593 14.3979 7.49593 14.2413C7.49593 14.0903 7.6408 13.9514 7.79121 13.9514C7.94762 13.9514 8.08662 14.0784 8.08662 14.2413C8.08662 14.4042 7.9537 14.5425 7.79121 14.5425Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.00851 16.2718C9.00851 16.0493 8.94197 15.9891 8.6592 15.8744V15.76C8.91786 15.6757 9.16478 15.597 9.45439 15.4702C9.47263 15.4702 9.49011 15.4823 9.49011 15.5305V15.9223C9.83417 15.6757 10.1295 15.4702 10.5339 15.4702C11.0454 15.4702 11.2261 15.844 11.2261 16.314V17.8686C11.2261 18.068 11.3591 18.068 11.5276 18.068H11.6364V18.2247C11.4248 18.2247 11.2141 18.2128 10.9974 18.2128C10.7803 18.2128 10.5632 18.2184 10.3462 18.2247V18.068H10.455C10.6238 18.068 10.7438 18.068 10.7438 17.8686V16.3084C10.7438 15.9645 10.5339 15.796 10.19 15.796C9.99694 15.796 9.68957 15.9523 9.49011 16.0855V17.8686C9.49011 18.068 9.62331 18.068 9.79209 18.068H9.90035V18.2247C9.68957 18.2247 9.47858 18.2128 9.26123 18.2128C9.04478 18.2128 8.82757 18.2184 8.61084 18.2247V18.068H8.71951C8.88809 18.068 9.00851 18.068 9.00851 17.8686V16.2718Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0945 16.5616C12.0822 16.6158 12.0822 16.706 12.0945 16.9111C12.13 17.4834 12.4985 17.9533 12.9801 17.9533C13.312 17.9533 13.5713 17.7724 13.7939 17.5499L13.878 17.6342C13.6007 18.0018 13.2573 18.3154 12.7636 18.3154C11.8051 18.3154 11.6123 17.3868 11.6123 17.0013C11.6123 15.82 12.4076 15.4702 12.829 15.4702C13.3177 15.4702 13.8424 15.7776 13.848 16.4166C13.848 16.4532 13.848 16.4889 13.8424 16.5252L13.7879 16.5616H12.0945ZM13.1617 16.3686C13.312 16.3686 13.3296 16.2901 13.3296 16.2175C13.3296 15.9106 13.1429 15.6635 12.8053 15.6635C12.438 15.6635 12.1848 15.9342 12.1126 16.3686H13.1617Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9868 18.068H14.1497C14.3177 18.068 14.4384 18.068 14.4384 17.8686V16.1755C14.4384 15.9891 14.2156 15.9523 14.1251 15.9042V15.8141C14.565 15.6271 14.8062 15.4702 14.8613 15.4702C14.8966 15.4702 14.9147 15.4884 14.9147 15.5489V16.0914H14.9274C15.0776 15.8564 15.3311 15.4702 15.6985 15.4702C15.8491 15.4702 16.0417 15.5726 16.0417 15.7897C16.0417 15.9523 15.9278 16.0977 15.7591 16.0977C15.5717 16.0977 15.5717 15.9523 15.3605 15.9523C15.2583 15.9523 14.9207 16.0914 14.9207 16.4532V17.8686C14.9207 18.068 15.0412 18.068 15.21 18.068H15.5471V18.2247C15.2157 18.2184 14.9634 18.2128 14.704 18.2128C14.4569 18.2128 14.2037 18.2184 13.9868 18.2247V18.068Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.3067 17.3866C16.3853 17.7844 16.6258 18.1223 17.0666 18.1223C17.4216 18.1223 17.5541 17.9051 17.5541 17.6943C17.5541 16.9829 16.2407 17.2121 16.2407 16.2419C16.2407 15.9041 16.512 15.4702 17.175 15.4702C17.3675 15.4702 17.6266 15.5249 17.8614 15.6455L17.9037 16.2597H17.7652C17.705 15.8802 17.4943 15.6634 17.1082 15.6634C16.8671 15.6634 16.6384 15.8018 16.6384 16.061C16.6384 16.7665 18.0362 16.5491 18.0362 17.4954C18.0362 17.8928 17.7171 18.3152 16.9997 18.3152C16.7589 18.3152 16.4751 18.2307 16.2648 18.1102L16.1982 17.417L16.3067 17.3866Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.4779 15.1087H23.3276C23.2129 14.4043 22.7126 14.1207 22.0381 14.1207C21.3443 14.1207 20.3383 14.5844 20.3383 16.0307C20.3383 17.2485 21.2063 18.1225 22.1342 18.1225C22.7303 18.1225 23.2256 17.7125 23.3458 17.0793L23.4845 17.1153L23.3458 17.9955C23.0927 18.1524 22.4115 18.3154 22.0133 18.3154C20.6038 18.3154 19.7119 17.4052 19.7119 16.0493C19.7119 14.8135 20.8148 13.9274 21.9959 13.9274C22.4839 13.9274 22.9538 14.0845 23.418 14.2474L23.4779 15.1087Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.6953 18.068H23.8094C23.9787 18.068 24.099 18.068 24.099 17.8687V14.5128C24.099 14.1206 24.0088 14.1087 23.7795 14.0423V13.9458C24.0204 13.8676 24.2738 13.7593 24.4006 13.6864C24.466 13.6508 24.5147 13.62 24.5324 13.62C24.5693 13.62 24.5812 13.6566 24.5812 13.7051V17.8687C24.5812 18.068 24.7139 18.068 24.8824 18.068H24.9845V18.2248C24.7802 18.2248 24.5693 18.2129 24.3522 18.2129C24.1353 18.2129 23.9186 18.2185 23.6953 18.2248V18.068Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.5649 17.8928C27.5649 18.0017 27.6308 18.0073 27.7329 18.0073C27.8056 18.0073 27.8956 18.0017 27.9746 18.0017V18.1285C27.7153 18.1523 27.2209 18.279 27.1062 18.3152L27.0761 18.2968V17.8086C26.7149 18.1038 26.4374 18.3152 26.0089 18.3152C25.6836 18.3152 25.3463 18.1038 25.3463 17.5983V16.055C25.3463 15.8981 25.3224 15.7474 24.9854 15.7177V15.6029C25.2025 15.5969 25.6836 15.5609 25.7622 15.5609C25.829 15.5609 25.829 15.6029 25.829 15.7357V17.2904C25.829 17.4713 25.829 17.9891 26.3533 17.9891C26.5578 17.9891 26.829 17.8328 27.082 17.6222V16.0006C27.082 15.8802 26.7929 15.8139 26.5763 15.754V15.6456C27.1181 15.6088 27.456 15.5609 27.5162 15.5609C27.5649 15.5609 27.5649 15.6029 27.5649 15.6694V17.8928Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.7635 15.9043C29.0045 15.6998 29.33 15.4702 29.6615 15.4702C30.3607 15.4702 30.7826 16.0796 30.7826 16.7363C30.7826 17.5256 30.2038 18.3154 29.3416 18.3154C28.8961 18.3154 28.661 18.1702 28.504 18.104L28.3238 18.2426L28.1974 18.1766C28.2513 17.8211 28.2817 17.4716 28.2817 17.1037V14.5128C28.2817 14.1206 28.1909 14.1087 27.9619 14.0423V13.9458C28.2032 13.8676 28.4561 13.7593 28.5826 13.6864C28.6491 13.6508 28.6971 13.62 28.7155 13.62C28.7514 13.62 28.7635 13.6568 28.7635 13.7051V15.9043ZM28.7635 17.5436C28.7635 17.7724 28.9807 18.1585 29.3843 18.1585C30.029 18.1585 30.3001 17.5256 30.3001 16.989C30.3001 16.3383 29.8065 15.796 29.3365 15.796C29.1126 15.796 28.9262 15.9409 28.7635 16.0796V17.5436Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.01721 21.181L6.02378 21.1745V19.9451C6.02378 19.676 5.83662 19.6366 5.73831 19.6366H5.66604V19.5383C5.82045 19.5383 5.97127 19.5513 6.1252 19.5513C6.25964 19.5513 6.39464 19.5383 6.5286 19.5383V19.6366H6.47982C6.34165 19.6366 6.18751 19.6628 6.18751 20.0531V21.5451C6.18751 21.6601 6.19076 21.7748 6.20686 21.8765H6.08222L4.39373 19.9939V21.3452C4.39373 21.6308 4.44921 21.7287 4.70172 21.7287H4.75755V21.8273C4.61654 21.8273 4.47567 21.8145 4.33466 21.8145C4.18744 21.8145 4.03639 21.8273 3.88867 21.8273V21.7287H3.93473C4.16091 21.7287 4.22979 21.5745 4.22979 21.313V19.9314C4.22979 19.7479 4.07846 19.6366 3.9315 19.6366H3.88867V19.5383C4.01305 19.5383 4.14115 19.5513 4.26551 19.5513C4.36423 19.5513 4.4593 19.5383 4.55761 19.5383L6.01721 21.181Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.20671 21.8904L6.07171 21.8857L4.40754 20.0309V21.3453C4.41148 21.6304 4.4548 21.7115 4.70172 21.7146H4.77198V21.8413H4.7574C4.61556 21.8413 4.47442 21.8282 4.33452 21.8282C4.18771 21.8282 4.037 21.8413 3.88842 21.8413H3.87402V21.7146H3.9346C4.1513 21.7134 4.21327 21.5741 4.21562 21.3129V19.9319C4.215 19.7572 4.07176 19.651 3.93149 19.651H3.87402V19.524H3.88842C4.01379 19.524 4.14211 19.5368 4.26515 19.5368C4.36298 19.5368 4.4577 19.524 4.56824 19.5291L6.0094 21.1513V19.9451C6.00774 19.6848 5.83371 19.6531 5.7383 19.651H5.65153V19.524H5.66603C5.82093 19.524 5.97188 19.5368 6.12505 19.5368C6.25853 19.5368 6.3929 19.524 6.52845 19.524H6.54289V19.651H6.47967C6.34426 19.6544 6.2054 19.6664 6.20139 20.0531V21.5451C6.20139 21.66 6.20498 21.7744 6.22074 21.8739L6.22378 21.8904H6.20671ZM6.08222 21.8618H6.19075C6.17611 21.7631 6.17348 21.6542 6.17348 21.5451V20.0531C6.17348 19.6595 6.33846 19.6224 6.47967 19.6222H6.51422V19.5524C6.38496 19.5534 6.25549 19.5653 6.12505 19.5653C5.97485 19.5653 5.82887 19.5534 5.68068 19.5524L5.68034 19.6222H5.7383C5.8391 19.6224 6.03779 19.6672 6.03779 19.9451L6.03344 21.1848L6.02701 21.1911L6.01582 21.2017L4.55746 19.5524C4.46005 19.5524 4.36519 19.5653 4.26515 19.5653C4.14501 19.5653 4.02186 19.5534 3.90294 19.5524L3.90232 19.6222H3.93149C4.08528 19.6224 4.24353 19.7398 4.24353 19.9319V21.3129C4.24353 21.5753 4.17044 21.7429 3.9346 21.7438L3.90294 21.7429V21.8133C4.04494 21.8122 4.1913 21.8001 4.33452 21.8001C4.47131 21.8001 4.60783 21.8122 4.74317 21.8133V21.7438H4.70172C4.44361 21.7429 4.3797 21.6304 4.37949 21.3453V19.9572L6.08222 21.8618ZM6.0094 21.1745V21.1732L6.00677 21.1712L6.0094 21.1745Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.0201 19.7022C6.77387 19.7022 6.76427 19.7615 6.71515 20.0006H6.6167C6.62962 19.9088 6.64585 19.817 6.65608 19.722C6.66921 19.6297 6.67577 19.5383 6.67577 19.4434H6.75439C6.78078 19.5418 6.86272 19.5382 6.9517 19.5382H8.64309C8.73208 19.5382 8.81388 19.535 8.82058 19.4366L8.89892 19.45C8.88621 19.5383 8.87281 19.6269 8.86328 19.7156C8.85678 19.8041 8.85678 19.8924 8.85678 19.9809L8.75826 20.0174C8.75156 19.8962 8.73533 19.7022 8.51556 19.7022H7.97772V21.4468C7.97772 21.6998 8.09268 21.7287 8.24985 21.7287H8.31238V21.8272C8.18443 21.8272 7.95478 21.8146 7.77805 21.8146C7.58102 21.8146 7.3513 21.8272 7.22328 21.8272V21.7287H7.28588C7.46661 21.7287 7.55794 21.7126 7.55794 21.4536V19.7022H7.0201Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.31242 21.8412C8.18316 21.8412 7.95379 21.8282 7.77776 21.8282C7.58107 21.8282 7.35163 21.8412 7.22306 21.8412H7.20903V21.7145H7.28565C7.46638 21.7103 7.53899 21.7079 7.54307 21.4535V19.7162H7.01987V19.6875H7.57146V21.4535C7.57146 21.7168 7.46535 21.7434 7.28565 21.7436H7.23708V21.8129C7.36641 21.812 7.58735 21.8 7.77776 21.8C7.94847 21.8 8.16755 21.812 8.2975 21.8129V21.7436H8.24962C8.09093 21.7434 7.96333 21.7045 7.96333 21.4468V19.6875H8.51533C8.73531 19.6884 8.76446 19.8753 8.7713 19.9973L8.84232 19.9711C8.84232 19.8855 8.84267 19.7997 8.84847 19.7136C8.85821 19.6288 8.8701 19.5455 8.88239 19.4615L8.83258 19.4531C8.81731 19.5486 8.72487 19.5537 8.64273 19.5525H6.93434C6.8571 19.5525 6.77309 19.5489 6.74359 19.4573H6.68943C6.68894 19.548 6.68273 19.636 6.67036 19.7234C6.66055 19.8135 6.64549 19.9 6.6336 19.9869H6.70359C6.74663 19.7581 6.77475 19.6843 7.01987 19.6875V19.7162C6.77696 19.721 6.78228 19.7616 6.72881 20.0039L6.72646 20.0151H6.6001L6.60182 19.9981C6.61523 19.9066 6.63188 19.8144 6.64141 19.7192C6.65509 19.6283 6.66124 19.5373 6.66124 19.4433V19.4288H6.76542L6.76791 19.4391C6.78995 19.5218 6.85068 19.5224 6.93434 19.5239H8.64273C8.73406 19.5224 8.80059 19.5212 8.80619 19.4354L8.8073 19.4199L8.82222 19.4229L8.91493 19.4375L8.91258 19.452C8.89953 19.54 8.88675 19.6283 8.8768 19.7162C8.87072 19.8041 8.87072 19.8922 8.87072 19.9808V19.9908L8.86118 19.9946L8.74512 20.037L8.74436 20.018C8.73531 19.8947 8.72266 19.7162 8.51533 19.7162H7.99193V21.4468C7.99511 21.694 8.09321 21.7114 8.24962 21.7145H8.32631V21.8412H8.31242Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.00391 21.7287H9.05013C9.16778 21.7287 9.29276 21.7126 9.29276 21.5419V19.8239C9.29276 19.653 9.16778 19.6368 9.05013 19.6368H9.00391V19.5383C9.20329 19.5383 9.54514 19.5513 9.82003 19.5513C10.096 19.5513 10.4366 19.5383 10.6595 19.5383C10.6538 19.6793 10.6569 19.8962 10.6666 20.0402L10.5678 20.0663C10.552 19.853 10.5127 19.6829 10.1682 19.6829H9.71295V20.5416H10.1025C10.2992 20.5416 10.342 20.4305 10.3615 20.2532H10.4598C10.4532 20.3813 10.4498 20.5091 10.4498 20.6369C10.4498 20.7617 10.4532 20.8862 10.4598 21.0107L10.3615 21.0302C10.342 20.8337 10.3322 20.7059 10.1056 20.7059H9.71295V21.4695C9.71295 21.683 9.90232 21.683 10.1123 21.683C10.506 21.683 10.6796 21.6565 10.7781 21.2832L10.8695 21.3058C10.827 21.48 10.7879 21.6532 10.7584 21.8273C10.5483 21.8273 10.1712 21.8146 9.87668 21.8146C9.58085 21.8146 9.19099 21.8273 9.00391 21.8273V21.7287Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7579 21.8413C10.5475 21.8413 10.1702 21.8276 9.876 21.8276C9.58058 21.8276 9.19079 21.8413 9.00349 21.8413H8.98975V21.7146H9.04971C9.16834 21.7126 9.27632 21.7022 9.27784 21.5419V19.824C9.27632 19.6637 9.16834 19.6531 9.04971 19.651H8.98975V19.524H9.00349C9.20385 19.524 9.54493 19.5368 9.81976 19.5368C10.0954 19.5368 10.4359 19.524 10.6592 19.524H10.6737L10.6733 19.5391C10.6711 19.5882 10.6698 19.6465 10.6698 19.7082C10.6698 19.8215 10.6733 19.9458 10.6797 20.0391L10.6803 20.0508L10.6693 20.0542L10.5539 20.0843L10.5535 20.0674C10.5341 19.8546 10.5056 19.6999 10.168 19.6966H9.72594L9.72566 20.5272H10.1021C10.2911 20.5252 10.3249 20.4286 10.3472 20.2518L10.3479 20.2386H10.474L10.4738 20.2536C10.4675 20.3817 10.4636 20.5092 10.4636 20.6369C10.4636 20.7609 10.4675 20.8854 10.4738 21.0101L10.474 21.0219L10.4621 21.0247L10.3479 21.0474L10.3472 21.032C10.3244 20.8318 10.323 20.722 10.1054 20.7197H9.72594V21.4695C9.72642 21.6689 9.89824 21.6678 10.1119 21.6689C10.5068 21.6665 10.665 21.6472 10.7638 21.2794L10.7671 21.2661L10.7809 21.2684L10.886 21.2957L10.883 21.3092C10.8405 21.4827 10.8013 21.6561 10.7717 21.8296L10.7692 21.8413H10.7579ZM10.7457 21.813C10.7744 21.6472 10.8118 21.4816 10.852 21.3165L10.7875 21.3002C10.6893 21.667 10.499 21.6998 10.1119 21.6973C9.90529 21.6973 9.69872 21.6973 9.69761 21.4695V20.6916H10.1054C10.3344 20.6893 10.3575 20.8273 10.3738 21.0139L10.4447 20.9993C10.4383 20.8784 10.435 20.7571 10.435 20.6369C10.435 20.5138 10.4383 20.3909 10.4447 20.2672H10.3738C10.3554 20.4384 10.3019 20.5579 10.1021 20.5559H9.69761V19.6682H10.168C10.5089 19.6655 10.5654 19.842 10.5803 20.0483L10.6509 20.0291C10.6452 19.9366 10.6413 19.8177 10.6413 19.7082C10.6413 19.6521 10.6429 19.5988 10.6447 19.5524C10.4219 19.5534 10.0893 19.5653 9.81976 19.5653C9.55032 19.5653 9.21863 19.5534 9.01793 19.5524V19.6222H9.04971C9.16633 19.6224 9.30589 19.6427 9.30665 19.824V21.5419C9.30589 21.7229 9.16633 21.7429 9.04971 21.7438H9.01793V21.813C9.20882 21.8124 9.5879 21.8001 9.876 21.8001C10.1655 21.8001 10.5344 21.8124 10.7457 21.813Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3123 19.8856C11.3123 19.6465 11.181 19.6366 11.0792 19.6366H11.02V19.5383C11.125 19.5383 11.3284 19.5513 11.5286 19.5513C11.7249 19.5513 11.8826 19.5383 12.0563 19.5383C12.4689 19.5383 12.837 19.6496 12.837 20.1156C12.837 20.4105 12.6401 20.5906 12.3812 20.6929L12.9416 21.5318C13.0337 21.6706 13.0988 21.7095 13.2599 21.7287V21.8273C13.1514 21.8273 13.0465 21.8146 12.9386 21.8146C12.837 21.8146 12.7316 21.8273 12.6304 21.8273C12.3777 21.4962 12.1611 21.1422 11.9481 20.7645H11.732V21.4667C11.732 21.7191 11.8498 21.7287 12.0001 21.7287H12.0596V21.8273C11.8723 21.8273 11.6828 21.8146 11.4955 21.8146C11.3382 21.8146 11.184 21.8273 11.02 21.8273V21.7287H11.0792C11.201 21.7287 11.3123 21.6732 11.3123 21.5521V19.8856ZM11.732 20.6462H11.8922C12.2205 20.6462 12.3973 20.5219 12.3973 20.1348C12.3973 19.8432 12.2104 19.6563 11.9182 19.6563C11.8198 19.6563 11.7778 19.6664 11.732 19.6695V20.6462Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2595 21.8413C13.1495 21.8413 13.0452 21.8282 12.9374 21.8282C12.8374 21.8282 12.7326 21.8413 12.6184 21.8359C12.3667 21.5057 12.1512 21.1536 11.9394 20.7793H11.7456V21.4661C11.7492 21.7129 11.8482 21.7111 11.9997 21.7146H12.0733V21.8413H12.0588C11.8714 21.8413 11.6808 21.8282 11.495 21.8282C11.3384 21.8282 11.1843 21.8413 11.0196 21.8413H11.0054V21.7146H11.0788C11.1967 21.7137 11.2964 21.6623 11.2969 21.5521V19.8856C11.2944 19.6531 11.1806 19.6542 11.0788 19.651H11.0054V19.524H11.0196C11.1257 19.524 11.3282 19.5368 11.5282 19.5368C11.7239 19.5368 11.8812 19.524 12.056 19.524C12.4694 19.5249 12.8499 19.6387 12.8508 20.1151C12.8508 20.411 12.6552 20.5959 12.4024 20.6991L12.953 21.5241C13.0448 21.6601 13.1018 21.6941 13.2613 21.7146L13.2733 21.7165V21.8413H13.2595ZM11.7315 20.7504H11.9555L11.9596 20.7577C12.1732 21.1344 12.3886 21.4885 12.63 21.8133C12.7299 21.8133 12.8352 21.8001 12.9374 21.8001C13.042 21.8001 13.1433 21.8115 13.2451 21.813V21.741C13.0914 21.7223 13.0192 21.6758 12.9297 21.5399L12.3588 20.6863L12.375 20.6797C12.6318 20.5785 12.8221 20.4034 12.8222 20.1151C12.8221 19.6602 12.4682 19.5547 12.056 19.5524C11.8833 19.5524 11.7257 19.5657 11.5282 19.5657C11.3355 19.5657 11.1409 19.5534 11.0336 19.5524V19.6222H11.0788C11.1806 19.6224 11.3255 19.6393 11.3255 19.8856V21.5521C11.3255 21.6837 11.2022 21.7435 11.0788 21.7438H11.0336V21.813C11.1913 21.8124 11.341 21.8001 11.495 21.8001C11.6781 21.8001 11.8633 21.8124 12.0447 21.813V21.7438H11.9997C11.8504 21.7435 11.717 21.725 11.717 21.4661V20.7504H11.7315ZM11.7315 20.6603H11.717V19.6563L11.7295 19.6553C11.7745 19.6517 11.8186 19.6427 11.9178 19.6427C12.2165 19.6427 12.411 19.8367 12.4112 20.1357C12.4103 20.5272 12.2227 20.6603 11.8918 20.6603H11.7315ZM11.8918 20.6324C12.2165 20.6292 12.3801 20.5166 12.3832 20.1357C12.3813 19.8492 12.2034 19.6714 11.9178 19.6702C11.8293 19.6702 11.7874 19.6784 11.7456 19.6825V20.6324H11.8918Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.4857 21.181L15.4915 21.1745V19.9451C15.4915 19.676 15.3051 19.6366 15.2067 19.6366H15.1348V19.5383C15.289 19.5383 15.4393 19.5513 15.5938 19.5513C15.7286 19.5513 15.862 19.5383 15.9975 19.5383V19.6366H15.9481C15.8103 19.6366 15.6563 19.6628 15.6563 20.0531V21.5451C15.6563 21.6601 15.6595 21.7748 15.6756 21.8765H15.5515L13.8629 19.9939V21.3452C13.8629 21.6308 13.9183 21.7287 14.1707 21.7287H14.2266V21.8273C14.0857 21.8273 13.9445 21.8145 13.8035 21.8145C13.6555 21.8145 13.5049 21.8273 13.3574 21.8273V21.7287H13.403C13.6294 21.7287 13.6986 21.5745 13.6986 21.313V19.9314C13.6986 19.7479 13.5476 19.6366 13.4001 19.6366H13.3574V19.5383C13.4816 19.5383 13.6104 19.5513 13.7348 19.5513C13.8323 19.5513 13.9278 19.5383 14.0264 19.5383L15.4857 21.181Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.6756 21.8904L15.5409 21.8857L13.8765 20.0312V21.3452C13.8803 21.6308 13.9235 21.7115 14.1708 21.7146H14.2403V21.8413H14.2261C14.0843 21.8413 13.9436 21.8276 13.803 21.8276C13.6566 21.8276 13.5051 21.8413 13.3574 21.8413H13.3428V21.7146H13.4031C13.6197 21.7137 13.6817 21.5741 13.6839 21.3122V19.9314C13.6834 19.7566 13.5405 19.651 13.4002 19.651H13.3428V19.524H13.3574C13.4826 19.524 13.611 19.5368 13.7348 19.5368C13.8311 19.5368 13.926 19.524 14.036 19.5282L15.4776 21.1513V19.9451C15.4767 19.6848 15.3021 19.6525 15.2067 19.651H15.1202V19.524H15.1345C15.2894 19.524 15.4406 19.5368 15.5939 19.5368C15.7275 19.5368 15.8618 19.524 15.997 19.524H16.0115V19.651H15.9482C15.8128 19.6542 15.6735 19.6664 15.6703 20.0531V21.5451C15.6703 21.66 15.6731 21.7737 15.6899 21.8742L15.6915 21.8904H15.6756ZM15.5515 21.8618H15.6589C15.6446 21.7637 15.6417 21.6542 15.6417 21.5451V20.0531C15.6419 19.6595 15.8078 19.6231 15.9482 19.6222H15.9827V19.5524C15.8536 19.5534 15.724 19.5653 15.5939 19.5653C15.4432 19.5653 15.2971 19.5534 15.1488 19.5524V19.6222H15.2067C15.3078 19.6231 15.5064 19.6672 15.5064 19.9451L15.5017 21.1848L15.4957 21.1911L15.4854 21.2019L14.0265 19.5524C13.9289 19.5524 13.8338 19.5653 13.7348 19.5653C13.6131 19.5653 13.4906 19.5534 13.3714 19.5524V19.6222H13.4002C13.5545 19.6231 13.7123 19.7393 13.7123 19.9314V21.3122C13.7123 21.5753 13.6382 21.7429 13.4031 21.7438L13.3714 21.7435V21.8131C13.5131 21.8122 13.6591 21.8001 13.803 21.8001C13.9405 21.8001 14.0768 21.8122 14.2124 21.8131V21.7438H14.1708C13.9127 21.7435 13.8484 21.6308 13.8477 21.3452V19.9577L15.5515 21.8618ZM15.4776 21.1745V21.1737L15.4752 21.1712L15.4776 21.1745Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.5247 21.3586C16.4917 21.4697 16.4521 21.5559 16.4521 21.6141C16.4521 21.7128 16.5903 21.729 16.6981 21.729H16.7347V21.8274C16.603 21.8204 16.4692 21.8148 16.3373 21.8148C16.2192 21.8148 16.1018 21.8204 15.9834 21.8274V21.729H16.0034C16.131 21.729 16.2396 21.6534 16.2882 21.5157L16.8129 20.011C16.8558 19.8893 16.9148 19.7255 16.9348 19.6039C17.0391 19.568 17.1708 19.5028 17.2328 19.4629C17.243 19.4596 17.2491 19.4562 17.259 19.4562C17.269 19.4562 17.2751 19.4562 17.2822 19.4665C17.2919 19.4925 17.3014 19.5221 17.3117 19.5483L17.9153 21.2636C17.9547 21.378 17.9936 21.4993 18.0356 21.5982C18.0756 21.6902 18.1444 21.729 18.2531 21.729H18.2727V21.8274C18.125 21.8204 17.977 21.8148 17.8204 21.8148C17.6596 21.8148 17.4951 21.8204 17.3279 21.8274V21.729H17.364C17.439 21.729 17.5677 21.716 17.5677 21.6339C17.5677 21.5916 17.5381 21.503 17.5015 21.3976L17.3737 21.0174H16.6294L16.5247 21.3586ZM17.0035 19.9059H16.9966L16.6919 20.834H17.3046L17.0035 19.9059Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.2722 21.8414C18.1248 21.8351 17.977 21.8278 17.8208 21.8278C17.6601 21.8278 17.4965 21.8351 17.3292 21.8414L17.314 21.8421V21.714H17.3645C17.4405 21.714 17.5532 21.697 17.5535 21.6338C17.5542 21.5965 17.5248 21.5066 17.4887 21.4023L17.3638 21.0313H16.6405L16.5385 21.3627C16.5055 21.4742 16.4656 21.5609 16.4663 21.6142C16.4674 21.6943 16.5898 21.714 16.6986 21.714H16.749V21.8421L16.7341 21.8414C16.603 21.8351 16.4692 21.8278 16.338 21.8278C16.221 21.8278 16.1024 21.8351 15.985 21.8414L15.9697 21.8421V21.714H16.0038C16.1257 21.7138 16.2274 21.6441 16.2748 21.5109L16.8 20.0058C16.8424 19.8844 16.9019 19.7213 16.9302 19.5902C17.0331 19.5553 17.1651 19.4892 17.228 19.4496C17.2372 19.4463 17.2463 19.4421 17.2594 19.4421C17.2675 19.4416 17.2851 19.4438 17.2958 19.4609C17.3051 19.4878 17.3155 19.5172 17.3254 19.5437L17.9292 21.2588C17.9678 21.3736 18.007 21.4947 18.05 21.5919C18.0879 21.6793 18.1482 21.7138 18.2535 21.714H18.2867V21.8421L18.2722 21.8414ZM17.3427 21.8122C17.5049 21.8065 17.6642 21.8002 17.8208 21.8002C17.9729 21.8002 18.1159 21.8065 18.2584 21.8122V21.7435H18.2535C18.1411 21.7443 18.0638 21.7002 18.0236 21.6034C17.9809 21.5044 17.941 21.3826 17.9023 21.2678L17.2985 19.5526C17.2886 19.5264 17.2793 19.4971 17.2707 19.4738C17.2675 19.4706 17.2682 19.4706 17.2656 19.4706H17.2594C17.2528 19.4706 17.2489 19.4726 17.2404 19.4746C17.1774 19.5156 17.0459 19.5803 16.9483 19.6058C16.9284 19.7301 16.8693 19.8939 16.8267 20.0155L16.302 21.5202C16.2522 21.6628 16.1368 21.7438 16.0038 21.7435H15.9983V21.8122C16.1107 21.8065 16.2242 21.8002 16.338 21.8002C16.4649 21.8002 16.5942 21.8065 16.7197 21.8122V21.7435H16.6986C16.5915 21.7421 16.4423 21.7304 16.4386 21.6142C16.4388 21.5492 16.479 21.4653 16.5112 21.3544L16.6191 21.0036H17.3838L17.5151 21.3931C17.552 21.4986 17.5818 21.586 17.5818 21.6338C17.5769 21.7343 17.4389 21.7417 17.3645 21.7435H17.3427V21.8122ZM16.6724 20.848L16.9863 19.8912H17.004H17.0138L17.3254 20.848H16.6724ZM16.7117 20.8193H17.2857L17.0004 19.9406L16.7117 20.8193Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.417 19.7022C18.171 19.7022 18.1612 19.7615 18.1118 20.0006H18.0132C18.0261 19.9088 18.0429 19.817 18.053 19.722C18.0658 19.6297 18.0722 19.5383 18.0722 19.4434H18.1515C18.1772 19.5418 18.2593 19.5382 18.3478 19.5382H20.0402C20.1283 19.5382 20.2102 19.535 20.2167 19.4366L20.2951 19.45C20.283 19.5383 20.2699 19.6269 20.2596 19.7156C20.2524 19.8041 20.2524 19.8924 20.2524 19.9809L20.1545 20.0174C20.1487 19.8962 20.1322 19.7022 19.912 19.7022H19.3743V21.4468C19.3743 21.6998 19.4892 21.7287 19.6463 21.7287H19.709V21.8272C19.5809 21.8272 19.3517 21.8146 19.1743 21.8146C18.9779 21.8146 18.7478 21.8272 18.6199 21.8272V21.7287H18.6824C18.8631 21.7287 18.9546 21.7126 18.9546 21.4536V19.7022H18.417Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.709 21.8412C19.5801 21.8412 19.3502 21.8282 19.174 21.8282C18.9781 21.8282 18.7485 21.8412 18.62 21.8412H18.6054V21.7145H18.6823C18.8631 21.7103 18.9356 21.7079 18.94 21.4535L18.9398 19.7162H18.4169V19.6875H18.9686V21.4535C18.9686 21.7168 18.8624 21.7428 18.6823 21.7434H18.634V21.8131C18.7636 21.812 18.9839 21.8 19.174 21.8C19.3454 21.8 19.5649 21.812 19.6943 21.8131V21.7434H19.6461C19.4881 21.7428 19.3604 21.7048 19.3602 21.4468V19.6875H19.9119C20.1322 19.6884 20.1609 19.8753 20.1672 19.9973L20.2385 19.9711C20.2385 19.8855 20.2389 19.7997 20.2456 19.7139C20.2545 19.6294 20.2669 19.5455 20.2788 19.4618L20.2293 19.4531C20.2143 19.5486 20.1216 19.5539 20.0401 19.5525H18.331C18.2537 19.5533 18.17 19.5489 18.1402 19.4571H18.0866C18.0858 19.5478 18.0794 19.636 18.0665 19.7234C18.0576 19.8138 18.0418 19.9006 18.0293 19.9869H18.0998C18.1428 19.7581 18.1712 19.6839 18.4169 19.6875V19.7162C18.1737 19.7204 18.1791 19.7616 18.1256 20.0039L18.1232 20.0151H17.9966L17.9986 19.9988C18.0124 19.9066 18.0285 19.8144 18.0381 19.72C18.0515 19.6283 18.0576 19.5373 18.0576 19.4433V19.4288H18.1617L18.1645 19.4391C18.1874 19.5218 18.2471 19.5224 18.331 19.5239H20.0401C20.1308 19.5224 20.197 19.5212 20.2028 19.4356L20.2034 19.4199L20.2186 19.4229L20.3117 19.4375L20.3095 19.452C20.2959 19.54 20.2835 19.6283 20.2736 19.7162C20.2669 19.8041 20.2669 19.8923 20.2669 19.9808V19.9908L20.2573 19.9946L20.1413 20.037L20.1408 20.018C20.1322 19.8947 20.1191 19.7162 19.9119 19.7162H19.3883V21.4468C19.3917 21.694 19.4898 21.7114 19.6461 21.7145H19.7226V21.8412H19.709Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.4165 21.7287H20.4624C20.5806 21.7287 20.7047 21.7126 20.7047 21.5419V19.8239C20.7047 19.653 20.5806 19.6368 20.4624 19.6368H20.4165V19.5383C20.5445 19.5383 20.7409 19.5513 20.9014 19.5513C21.0657 19.5513 21.2625 19.5383 21.417 19.5383V19.6368H21.3709C21.2524 19.6368 21.1278 19.653 21.1278 19.8239V21.5419C21.1278 21.7126 21.2524 21.7287 21.3709 21.7287H21.417V21.8273C21.2594 21.8273 21.0625 21.8146 20.8987 21.8146C20.7378 21.8146 20.5445 21.8273 20.4165 21.8273V21.7287Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.4169 21.8413C21.2583 21.8413 21.0623 21.8276 20.8987 21.8276C20.7381 21.8276 20.5445 21.8413 20.4164 21.8413H20.4023V21.7146H20.4624C20.5806 21.7126 20.6896 21.7022 20.6904 21.5419V19.824C20.6896 19.6637 20.5806 19.6531 20.4624 19.651H20.4023V19.524H20.4164C20.5445 19.524 20.7418 19.5368 20.9012 19.5368C21.0647 19.5368 21.2614 19.524 21.4169 19.524H21.4305V19.651H21.3709C21.2509 19.6531 21.143 19.6637 21.1419 19.824V21.5419C21.143 21.7022 21.2509 21.7126 21.3709 21.7146H21.4305V21.8413H21.4169ZM21.402 21.813V21.7435H21.3709C21.2533 21.7435 21.1141 21.7229 21.1141 21.5419V19.824C21.1141 19.6427 21.2533 19.6224 21.3709 19.6222H21.402V19.5524C21.2508 19.5534 21.0609 19.5653 20.9012 19.5653C20.7456 19.5653 20.5579 19.5534 20.4307 19.5524V19.6222H20.4624C20.5789 19.6224 20.7186 19.6427 20.719 19.824V21.5419C20.7186 21.7229 20.5789 21.7435 20.4624 21.7435H20.4307V21.813C20.557 21.8115 20.7425 21.8001 20.8987 21.8001C21.0576 21.8001 21.2473 21.8122 21.402 21.813Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.7248 19.4892C23.4239 19.4892 23.9811 19.9225 23.9811 20.621C23.9811 21.3753 23.4398 21.8766 22.7416 21.8766C22.0461 21.8766 21.5151 21.4044 21.5151 20.6992C21.5151 20.0174 22.043 19.4892 22.7248 19.4892ZM22.7743 21.7323C23.4107 21.7323 23.5216 21.1711 23.5216 20.693C23.5216 20.2137 23.2632 19.6335 22.7186 19.6335C22.1449 19.6335 21.9742 20.1452 21.9742 20.5842C21.9742 21.1711 22.2432 21.7323 22.7743 21.7323Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.5005 20.699C21.5019 20.0094 22.0357 19.4759 22.7246 19.4748V19.5035C22.0505 19.5035 21.529 20.0245 21.5283 20.699C21.5296 21.3963 22.053 21.8615 22.7417 21.8617C23.4329 21.8615 23.9663 21.3673 23.9671 20.6204C23.9665 19.9306 23.4181 19.5041 22.7246 19.5035V19.4748C23.4286 19.4755 23.9938 19.9131 23.995 20.6204C23.9943 21.3825 23.4467 21.8891 22.7417 21.8903C22.0403 21.8891 21.5019 21.412 21.5005 20.699ZM21.9597 20.5841C21.9607 20.1428 22.1329 19.6188 22.7184 19.6188C23.2753 19.62 23.5349 20.211 23.536 20.6928C23.5349 21.171 23.4224 21.7456 22.7744 21.7456V21.7177C23.3979 21.7173 23.5062 21.171 23.5072 20.6928C23.5072 20.2178 23.2514 19.6486 22.7184 19.6477C22.1558 19.6483 21.9896 20.1473 21.9882 20.5841C21.9884 21.1682 22.2551 21.7169 22.7744 21.7177V21.7456C22.2301 21.7451 21.9607 21.1744 21.9597 20.5841Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.1908 21.181L26.1976 21.1745V19.9451C26.1976 19.676 26.0101 19.6366 25.9118 19.6366H25.8404V19.5383C25.994 19.5383 26.1453 19.5513 26.2989 19.5513C26.4337 19.5513 26.5682 19.5383 26.7027 19.5383V19.6366H26.6534C26.516 19.6366 26.3612 19.6628 26.3612 20.0531V21.5451C26.3612 21.6601 26.3647 21.7748 26.3813 21.8765H26.2566L24.5675 19.9939V21.3452C24.5675 21.6308 24.6235 21.7287 24.8754 21.7287H24.9317V21.8273C24.7905 21.8273 24.6498 21.8145 24.5088 21.8145C24.361 21.8145 24.2101 21.8273 24.0625 21.8273V21.7287H24.1086C24.3353 21.7287 24.4037 21.5745 24.4037 21.313V19.9314C24.4037 19.7479 24.2533 19.6366 24.105 19.6366H24.0625V19.5383C24.1871 19.5383 24.3149 19.5513 24.4398 19.5513C24.538 19.5513 24.6325 19.5383 24.7313 19.5383L26.1908 21.181Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.3811 21.8904L26.2454 21.8857L24.5812 20.0312V21.3453C24.5851 21.6308 24.6284 21.7111 24.8746 21.714H24.9453V21.8413H24.9313C24.7894 21.8413 24.6486 21.8282 24.5083 21.8282C24.3614 21.8282 24.2104 21.8413 24.0617 21.8413H24.0483V21.714H24.108C24.3241 21.7134 24.3865 21.5741 24.3891 21.3129V19.9314C24.3889 19.7566 24.2456 19.651 24.1047 19.651H24.0483V19.524H24.0617C24.1875 19.524 24.3154 19.5368 24.4392 19.5368C24.5365 19.5368 24.6307 19.524 24.742 19.5291L26.1828 21.1513V19.9451C26.1817 19.6848 26.007 19.6531 25.9113 19.651H25.825V19.524H25.84C25.994 19.524 26.1453 19.5368 26.2982 19.5368C26.4323 19.5368 26.5662 19.524 26.7024 19.524H26.7162V19.651H26.6529C26.5177 19.6544 26.3782 19.6669 26.3755 20.0531V21.5451C26.3755 21.66 26.3781 21.7744 26.394 21.8742L26.3968 21.8904H26.3811ZM26.2562 21.8618H26.3637C26.3498 21.7631 26.3465 21.6542 26.3465 21.5451V20.0531C26.3465 19.6589 26.5121 19.6231 26.6529 19.6222H26.6884V19.5524C26.5582 19.5534 26.4292 19.5653 26.2982 19.5653C26.1488 19.5653 26.0022 19.5534 25.8537 19.5524V19.6222H25.9113C26.0126 19.6231 26.2106 19.6678 26.2106 19.9451L26.2072 21.1848L26.2008 21.1911L26.1904 21.2019L24.7311 19.5524C24.634 19.5524 24.5385 19.5653 24.4392 19.5653C24.3183 19.5653 24.1952 19.5534 24.0759 19.5524V19.6222H24.1047C24.2588 19.6231 24.4173 19.7393 24.4173 19.9314V21.3129C24.4173 21.5753 24.344 21.7429 24.108 21.7438L24.0759 21.7435V21.8131C24.2183 21.8122 24.3642 21.8001 24.5083 21.8001C24.6451 21.8001 24.7811 21.8122 24.917 21.8131V21.7438H24.8746C24.6173 21.7435 24.5528 21.6308 24.5528 21.3453V19.9572L26.2562 21.8618ZM26.1828 21.1745V21.1737L26.1802 21.1712L26.1828 21.1745Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.2292 21.3586C27.197 21.4697 27.1574 21.5559 27.1574 21.6141C27.1574 21.7128 27.2956 21.729 27.4031 21.729H27.4397V21.8274C27.3083 21.8204 27.1738 21.8148 27.0425 21.8148C26.9244 21.8148 26.8066 21.8204 26.689 21.8274V21.729H26.7076C26.8362 21.729 26.9448 21.6534 26.9927 21.5157L27.5185 20.011C27.5608 19.8893 27.6202 19.7255 27.6391 19.6039C27.7444 19.568 27.8753 19.5028 27.9384 19.4629C27.9476 19.4596 27.9542 19.4562 27.9644 19.4562C27.9739 19.4562 27.9801 19.4562 27.9868 19.4665C27.9968 19.4925 28.0066 19.5221 28.0165 19.5483L28.6199 21.2636C28.659 21.378 28.6986 21.4993 28.7414 21.5982C28.7808 21.6902 28.8495 21.729 28.9576 21.729H28.9779V21.8274C28.83 21.8204 28.6823 21.8148 28.5248 21.8148C28.3645 21.8148 28.2002 21.8204 28.0328 21.8274V21.729H28.0691C28.1441 21.729 28.2727 21.716 28.2727 21.6339C28.2727 21.5916 28.2433 21.503 28.2067 21.3976L28.0788 21.0174H27.3346L27.2292 21.3586ZM27.7087 19.9059H27.7021L27.3963 20.834H28.0105L27.7087 19.9059Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.9764 21.8414C28.8287 21.8356 28.6814 21.8282 28.525 21.8282C28.365 21.8282 28.2007 21.8356 28.0336 21.8414L28.0191 21.8422V21.7147H28.069C28.1452 21.7147 28.2581 21.697 28.2583 21.6339C28.2591 21.5965 28.2295 21.5071 28.1926 21.4024L28.0682 21.0314H27.3443L27.243 21.3628C27.21 21.4751 27.1713 21.5609 27.1717 21.614C27.1717 21.6943 27.2947 21.7147 27.403 21.7147H27.4532V21.8422L27.4384 21.8414C27.3074 21.8356 27.1731 21.8282 27.0426 21.8282C26.925 21.8282 26.8074 21.8356 26.689 21.8414L26.6748 21.8422V21.7147H26.7077C26.83 21.7141 26.9322 21.6441 26.9802 21.511L27.5047 20.0059C27.5468 19.8845 27.606 19.7214 27.6348 19.5908C27.7378 19.555 27.8695 19.4892 27.9333 19.4496C27.9417 19.4464 27.9509 19.4425 27.9643 19.4425C27.9728 19.4417 27.99 19.4438 28.0001 19.4617C28.01 19.4875 28.0197 19.5173 28.0304 19.5437L28.6334 21.2588C28.6729 21.3736 28.712 21.4948 28.7545 21.5926C28.7932 21.6793 28.8525 21.7138 28.9574 21.7147H28.9912V21.8422L28.9764 21.8414ZM28.0469 21.8125C28.2091 21.8065 28.3686 21.8002 28.525 21.8002C28.6774 21.8002 28.8201 21.8065 28.9632 21.8123L28.9628 21.7436H28.9574C28.8463 21.7439 28.7689 21.7001 28.728 21.6035C28.6848 21.5044 28.6458 21.3826 28.6065 21.2682L28.0031 19.5526C27.9934 19.5265 27.983 19.4972 27.9753 19.4744C27.9725 19.4706 27.9728 19.4706 27.9708 19.4706H27.9643C27.9573 19.4706 27.9537 19.4729 27.9459 19.4751C27.8817 19.5152 27.7505 19.581 27.6536 19.6059C27.6333 19.7301 27.5737 19.8937 27.5315 20.0155L27.0064 21.5203C26.9564 21.6628 26.8419 21.7439 26.7077 21.7436H26.7029V21.8123C26.8158 21.8065 26.9285 21.8002 27.0426 21.8002C27.1695 21.8002 27.2993 21.8065 27.4252 21.8123V21.7436H27.403C27.2964 21.7422 27.1469 21.7308 27.1427 21.614C27.1436 21.5493 27.184 21.4656 27.2161 21.3545L27.3239 21.0037H28.0883L28.2201 21.3931C28.2561 21.4986 28.2861 21.586 28.2861 21.6339C28.2814 21.7343 28.1435 21.7417 28.069 21.7436H28.0469V21.8125ZM27.3769 20.8479L27.6918 19.8912H27.7088H27.7187L28.0288 20.8479H27.3769ZM27.4165 20.8194H27.9902L27.7049 19.9412L27.4165 20.8194Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.8042 21.5057C29.8042 21.6375 29.8953 21.6763 30.0005 21.69C30.1347 21.6998 30.2824 21.6998 30.4338 21.683C30.5713 21.6665 30.6893 21.5883 30.7482 21.5057C30.8003 21.4337 30.8298 21.3418 30.8499 21.2698H30.9448C30.9087 21.4567 30.8628 21.6406 30.8235 21.8273C30.5355 21.8273 30.246 21.8146 29.9579 21.8146C29.6691 21.8146 29.3808 21.8273 29.0923 21.8273V21.7287H29.1377C29.256 21.7287 29.3844 21.7126 29.3844 21.5093V19.8239C29.3844 19.653 29.256 19.6366 29.1377 19.6366H29.0923V19.5383C29.2658 19.5383 29.4366 19.5513 29.6102 19.5513C29.7777 19.5513 29.9413 19.5383 30.109 19.5383V19.6366H30.0266C29.902 19.6366 29.8042 19.6402 29.8042 19.8139V21.5057Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.8234 21.8413C30.5342 21.8413 30.2453 21.8282 29.9577 21.8282C29.6692 21.8282 29.3807 21.8413 29.0915 21.8413H29.0776V21.7146H29.1375C29.256 21.7117 29.3686 21.7034 29.37 21.5093V19.8234C29.3686 19.6637 29.2565 19.6531 29.1375 19.651H29.0776V19.524H29.0915C29.2661 19.524 29.4368 19.5368 29.6097 19.5368C29.7767 19.5368 29.94 19.524 30.1088 19.524H30.122V19.651H30.0263C29.8992 19.6542 29.8202 19.6485 29.8174 19.8139V21.5057C29.8182 21.6283 29.8985 21.6611 30.0011 21.6757C30.0587 21.6797 30.1198 21.6818 30.1829 21.6818C30.2631 21.6818 30.3464 21.6781 30.4311 21.6691C30.5647 21.6533 30.6796 21.576 30.7364 21.4979C30.787 21.4277 30.8156 21.3379 30.8354 21.2665L30.8382 21.2557H30.9618L30.9589 21.2729C30.9218 21.4604 30.8767 21.6433 30.8369 21.8303L30.8343 21.8413H30.8234ZM30.8114 21.813C30.8493 21.6349 30.8921 21.4607 30.9277 21.2838H30.86C30.8399 21.3552 30.8106 21.4432 30.7592 21.5146C30.6979 21.5995 30.5765 21.6797 30.4342 21.6973C30.3485 21.706 30.2632 21.7105 30.1829 21.7105C30.1193 21.7105 30.0581 21.7076 29.9983 21.7034C29.8917 21.6917 29.7885 21.6459 29.7887 21.5057V19.8139C29.7887 19.6316 29.904 19.6222 30.0263 19.6222H30.0939V19.5524C29.9324 19.5534 29.7729 19.5657 29.6097 19.5657C29.4403 19.5657 29.2741 19.5534 29.1062 19.5524V19.6222H29.1375C29.2544 19.6222 29.3976 19.6427 29.3976 19.8234V21.5093C29.3976 21.7215 29.2551 21.7435 29.1375 21.7435H29.1062V21.813C29.3895 21.8124 29.673 21.8001 29.9577 21.8001C30.2429 21.8001 30.5275 21.8124 30.8114 21.813Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4229 7.96136C10.4229 4.89403 12.9094 2.40755 15.9765 2.40755C19.0438 2.40755 21.5303 4.89403 21.5303 7.96136C21.5303 11.0286 19.0438 13.5153 15.9765 13.5153C12.9094 13.5153 10.4229 11.0286 10.4229 7.96136Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3355 7.85195C19.3332 6.42972 18.4443 5.21676 17.1916 4.7364V10.9673C18.4443 10.4863 19.3332 9.27446 19.3355 7.85195ZM14.8019 10.9661V4.73703C13.5503 5.2189 12.6626 6.43014 12.6593 7.85195C12.6626 9.27349 13.5503 10.4846 14.8019 10.9661ZM15.9973 2.58541C13.0888 2.58653 10.7323 4.94345 10.7319 7.85195C10.7323 10.7602 13.0888 13.1167 15.9973 13.1172C18.9058 13.1167 21.2628 10.7602 21.2635 7.85195C21.2628 4.94345 18.9058 2.58653 15.9973 2.58541ZM15.9844 13.6142C12.8017 13.6294 10.1821 11.0508 10.1821 7.91206C10.1821 4.48169 12.8017 2.10901 15.9844 2.10963H17.4759C20.6211 2.10901 23.4915 4.48058 23.4915 7.91206C23.4915 11.0497 20.6211 13.6142 17.4759 13.6142H15.9844Z",
          fill: "#0069AA"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.76416 21.7287H2.81021C2.92813 21.7287 3.05276 21.7126 3.05276 21.5419V19.8239C3.05276 19.653 2.92813 19.6368 2.81021 19.6368H2.76416V19.5383C2.89201 19.5383 3.08875 19.5513 3.24987 19.5513C3.41372 19.5513 3.61021 19.5383 3.76438 19.5383V19.6368H3.71807C3.60065 19.6368 3.47578 19.653 3.47578 19.8239V21.5419C3.47578 21.7126 3.60065 21.7287 3.71807 21.7287H3.76438V21.8273C3.60711 21.8273 3.40987 21.8146 3.24652 21.8146C3.08553 21.8146 2.89201 21.8273 2.76416 21.8273V21.7287Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.76449 21.8413C3.60585 21.8413 3.40961 21.8282 3.24638 21.8282C3.08589 21.8282 2.893 21.8413 2.76427 21.8413H2.75V21.7146H2.81008C2.92912 21.7117 3.03735 21.7022 3.03835 21.5419V19.824C3.03735 19.6635 2.92912 19.6531 2.81008 19.651H2.75V19.524H2.76427C2.893 19.524 3.08961 19.5368 3.24998 19.5368C3.41308 19.5368 3.60945 19.524 3.76449 19.524H3.77914V19.651H3.71881C3.59965 19.6531 3.49079 19.6635 3.49017 19.824V21.5419C3.49079 21.7022 3.59965 21.7117 3.71881 21.7146H3.77914V21.8413H3.76449ZM3.75033 21.8133L3.75046 21.7435H3.71881C3.60151 21.7435 3.46212 21.7229 3.46137 21.5419V19.824C3.46212 19.6427 3.60151 19.6224 3.71881 19.6224H3.75033V19.5524C3.59903 19.5525 3.40899 19.5657 3.24998 19.5657C3.09421 19.5657 2.90565 19.5534 2.77867 19.5524V19.6224H2.81008C2.927 19.6224 3.06665 19.6427 3.06665 19.824V21.5419C3.06665 21.7229 2.927 21.7435 2.81008 21.7435H2.77867V21.8133C2.90565 21.8122 3.09085 21.8001 3.24638 21.8001C3.40613 21.8001 3.59568 21.8124 3.75033 21.8133Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.9047 19.4453C31.1026 19.4453 31.2502 19.5973 31.2502 19.7914C31.2502 19.9854 31.1026 20.1357 30.9047 20.1357C30.7073 20.1357 30.5596 19.9854 30.5596 19.7914C30.5596 19.5973 30.7073 19.4453 30.9047 19.4453ZM30.9047 20.0715C31.0596 20.0715 31.178 19.9399 31.178 19.7914C31.178 19.6427 31.061 19.51 30.9047 19.51C30.7494 19.51 30.6311 19.6427 30.6311 19.7914C30.6311 19.9399 30.7494 20.0715 30.9047 20.0715ZM30.733 19.9735V19.9567C30.7753 19.9506 30.7832 19.9518 30.7832 19.926V19.67C30.7832 19.634 30.7796 19.6216 30.7344 19.6236V19.606H30.9112C30.9719 19.606 31.0278 19.635 31.0278 19.6978C31.0278 19.7491 30.9941 19.7872 30.9462 19.802L31.003 19.8811C31.0295 19.9169 31.0596 19.9506 31.079 19.9626V19.9735H31.0119C30.9796 19.9735 30.951 19.9057 30.8877 19.8148H30.8495V19.9292C30.8495 19.9518 30.8575 19.9506 30.8999 19.9567V19.9735H30.733ZM30.8495 19.7914H30.8902C30.9348 19.7914 30.9554 19.7578 30.9554 19.7033C30.9554 19.6484 30.9236 19.6289 30.888 19.6289H30.8495V19.7914Z",
          fill: "#1A1919"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M32 0.300015H2C1.33726 0.300015 0.8 0.837274 0.8 1.50002V22.5C0.8 23.1628 1.33726 23.7 2 23.7H32C32.6627 23.7 33.2 23.1628 33.2 22.5V1.50002C33.2 0.837274 32.6627 0.300015 32 0.300015ZM2 1.52588e-05C1.17157 1.52588e-05 0.5 0.671588 0.5 1.50002V22.5C0.5 23.3284 1.17157 24 2 24H32C32.8284 24 33.5 23.3284 33.5 22.5V1.50002C33.5 0.671588 32.8284 1.52588e-05 32 1.52588e-05H2Z",
          fill: "#0069AA"
        }
      )
    ]
  }
);
var GenericCardIcon = (props) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
  "svg",
  {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "22",
    viewBox: "0 0 34 22",
    fill: "none",
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M31.3602 21.4999H2.63983C1.46033 21.4999 0.5 20.6006 0.5 19.4899V2.50395C0.5 1.39932 1.46033 0.499939 2.63983 0.499939H31.3537C32.5396 0.499939 33.4999 1.39932 33.4999 2.50395V19.4899C33.5 20.6006 32.5397 21.4999 31.3602 21.4999Z",
          fill: "#B2B2B2"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M7.40939 10.7035H4.24472C3.76131 10.7035 3.36816 10.3103 3.36816 9.82693V7.72574C3.36816 7.24233 3.76131 6.84918 4.24472 6.84918H7.40939C7.8928 6.84918 8.28595 7.24233 8.28595 7.72574V9.82693C8.27951 10.3168 7.89274 10.7035 7.40939 10.7035Z",
          fill: "#424566"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M7.40957 10.652H4.23847C3.78731 10.652 3.41992 10.2846 3.41992 9.8334V7.72577C3.41992 7.27461 3.78731 6.90723 4.23847 6.90723H7.40957C7.86073 6.90723 8.22812 7.27461 8.22812 7.72577V9.8334C8.22812 10.2846 7.86073 10.652 7.40957 10.652Z",
          fill: "#6E6E6E"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M8.22812 8.84723V8.71833H6.55233V8.15114L6.98417 7.7193H8.22812C8.22812 7.67417 8.22168 7.62909 8.21524 7.5904H6.95197C6.93265 7.5904 6.91972 7.59684 6.90684 7.60972L6.45568 8.06088H5.88844V6.91364H5.75954V8.06088H5.1988L4.74764 7.60972C4.73544 7.59802 4.7194 7.59115 4.70251 7.5904H3.4328C3.42636 7.62909 3.41992 7.67417 3.41992 7.7193H4.67675L5.10215 8.1447V8.71833H3.41992V8.84723H5.10215V9.42085L4.67675 9.84625H3.41992C3.41992 9.89138 3.42636 9.93646 3.4328 9.97515H4.70251C4.72183 9.97515 4.73476 9.96871 4.74764 9.95583L5.1988 9.50468H5.75954V10.6519H5.88844V9.50468H6.45563L6.90679 9.95583C6.91967 9.96871 6.93255 9.97515 6.95192 9.97515H8.21519C8.22163 9.93646 8.22807 9.89138 8.22807 9.84625H6.98412L6.55228 9.41441V8.84723H8.22812ZM6.42343 9.37572H5.23105V8.18334H6.42343V9.37572Z",
          fill: "#393939"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M30.0456 10.6132C30.0165 10.6137 29.9878 10.6071 29.9618 10.5939C29.8651 10.5488 29.8265 10.4327 29.8781 10.3361C30.3743 9.34995 30.3743 8.22203 29.8781 7.23588C29.8329 7.13918 29.8716 7.02321 29.9618 6.97808C30.0585 6.93295 30.1745 6.97164 30.2196 7.06185C30.7739 8.15757 30.7739 9.4144 30.2196 10.5101C30.1809 10.5746 30.1165 10.6132 30.0456 10.6132ZM29.3817 10.2458C29.9038 9.3177 29.9038 8.24778 29.3817 7.31965C29.3301 7.22944 29.2141 7.19075 29.1175 7.24876C29.0273 7.30033 28.9886 7.41636 29.0466 7.51301C29.5042 8.32511 29.5042 9.25325 29.0466 10.0589C28.995 10.1491 29.0273 10.2716 29.1175 10.3232C29.1467 10.3406 29.1802 10.3495 29.2142 10.3489C29.2786 10.3425 29.343 10.3038 29.3817 10.2458ZM28.5567 9.98158C29.0659 9.24037 29.0659 8.31868 28.5567 7.57102C28.4987 7.48081 28.3762 7.46144 28.286 7.51945C28.1958 7.57746 28.1765 7.69992 28.2345 7.79013C28.647 8.39601 28.647 9.15654 28.2345 9.76242C28.1765 9.85263 28.1958 9.96865 28.286 10.0331C28.3183 10.0589 28.3569 10.0653 28.3956 10.0653C28.46 10.0718 28.518 10.0396 28.5567 9.98158ZM27.6866 9.73666C27.9702 9.47885 28.1249 9.13722 28.1249 8.78277C28.1249 8.42831 27.9702 8.08668 27.6866 7.82888C27.6093 7.75799 27.4868 7.75799 27.4159 7.84176C27.345 7.91909 27.345 8.04155 27.4288 8.11244C27.6286 8.29936 27.7382 8.53784 27.7382 8.78277C27.7382 9.02769 27.6286 9.26618 27.4288 9.45309C27.3515 9.52399 27.345 9.64645 27.4159 9.72378C27.4546 9.76247 27.5061 9.78823 27.5577 9.78823C27.6028 9.78823 27.6479 9.76891 27.6866 9.73666Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M3.61321 4.18728C3.50363 4.18728 3.41986 4.10351 3.41986 3.99393V3.23339C3.41986 3.12381 3.50363 3.04004 3.61321 3.04004C3.72279 3.04004 3.80656 3.12381 3.80656 3.23339V3.98749C3.80656 4.09707 3.72279 4.18728 3.61321 4.18728ZM4.85716 3.99393V3.23339C4.85716 3.12381 4.77339 3.04004 4.6638 3.04004C4.55422 3.04004 4.47045 3.12381 4.47045 3.23339V3.98749C4.47045 4.09707 4.55422 4.18084 4.6638 4.18084C4.77333 4.18728 4.85716 4.09707 4.85716 3.99393ZM5.91419 3.99393V3.23339C5.91419 3.12381 5.83042 3.04004 5.72084 3.04004C5.61125 3.04004 5.52748 3.12381 5.52748 3.23339V3.98749C5.52748 4.09707 5.61125 4.18084 5.72084 4.18084C5.82393 4.18728 5.91419 4.09707 5.91419 3.99393ZM6.96479 3.99393V3.23339C6.96479 3.12381 6.88102 3.04004 6.77143 3.04004C6.66185 3.04004 6.57808 3.12381 6.57808 3.23339V3.98749C6.57808 4.09707 6.66185 4.18084 6.77143 4.18084C6.88096 4.18728 6.96479 4.09707 6.96479 3.99393ZM4.0128 15.6858H3.98054C3.65829 15.6858 3.39404 15.4215 3.39404 15.0993V14.184C3.39404 13.8617 3.65829 13.5975 3.98054 13.5975H4.0128C4.33505 13.5975 4.5993 13.8617 4.5993 14.184V15.0993C4.59957 15.1764 4.58459 15.2527 4.55521 15.324C4.52583 15.3953 4.48264 15.4601 4.42812 15.5146C4.37361 15.5691 4.30884 15.6123 4.23756 15.6417C4.16628 15.671 4.08989 15.686 4.0128 15.6858ZM3.9806 13.9842C3.92769 13.9844 3.87702 14.0055 3.83961 14.043C3.80219 14.0804 3.78106 14.131 3.7808 14.1839V15.0992C3.78106 15.1521 3.80219 15.2028 3.83961 15.2402C3.87702 15.2776 3.92769 15.2987 3.9806 15.299H4.01285C4.06576 15.2987 4.11643 15.2776 4.15384 15.2402C4.19126 15.2028 4.21239 15.1521 4.21264 15.0992V14.1839C4.21239 14.131 4.19126 14.0804 4.15384 14.043C4.11643 14.0055 4.06576 13.9844 4.01285 13.9842H3.9806ZM5.579 15.6858H5.54675C5.22449 15.6858 4.96025 15.4215 4.96025 15.0993V14.184C4.96025 13.8617 5.22449 13.5975 5.54675 13.5975H5.579C5.90126 13.5975 6.1655 13.8617 6.1655 14.184V15.0993C6.16578 15.1764 6.15079 15.2527 6.12141 15.324C6.09203 15.3953 6.04884 15.4601 5.99433 15.5146C5.93981 15.5691 5.87505 15.6123 5.80377 15.6417C5.73249 15.671 5.6561 15.686 5.579 15.6858ZM5.5468 13.9842C5.49389 13.9844 5.44322 14.0055 5.40581 14.043C5.3684 14.0804 5.34727 14.131 5.34701 14.1839V15.0992C5.34727 15.1521 5.3684 15.2028 5.40581 15.2402C5.44322 15.2776 5.49389 15.2987 5.5468 15.299H5.57906C5.63197 15.2987 5.68264 15.2776 5.72005 15.2402C5.75746 15.2028 5.77859 15.1521 5.77885 15.0992V14.1839C5.77859 14.131 5.75746 14.0804 5.72005 14.043C5.68264 14.0055 5.63197 13.9844 5.57906 13.9842H5.5468ZM7.14526 15.6858H7.11301C6.79075 15.6858 6.52651 15.4215 6.52651 15.0993V14.184C6.52651 13.8617 6.79075 13.5975 7.11301 13.5975H7.14526C7.46752 13.5975 7.73176 13.8617 7.73176 14.184V15.0993C7.73176 15.4215 7.46752 15.6858 7.14526 15.6858ZM7.11301 13.9842C7.0601 13.9844 7.00943 14.0055 6.97202 14.043C6.9346 14.0804 6.91347 14.131 6.91321 14.1839V15.0992C6.91347 15.1521 6.9346 15.2028 6.97202 15.2402C7.00943 15.2776 7.0601 15.2987 7.11301 15.299H7.14526C7.19817 15.2987 7.24884 15.2776 7.28625 15.2402C7.32367 15.2028 7.3448 15.1521 7.34505 15.0992V14.1839C7.3448 14.131 7.32367 14.0804 7.28625 14.043C7.24884 14.0055 7.19817 13.9844 7.14526 13.9842H7.11301ZM8.71147 15.6858H8.67921C8.35696 15.6858 8.09271 15.4215 8.09271 15.0993V14.184C8.09271 13.8617 8.35696 13.5975 8.67921 13.5975H8.71147C9.03372 13.5975 9.29797 13.8617 9.29797 14.184V15.0993C9.29797 15.4215 9.03372 15.6858 8.71147 15.6858ZM8.67921 13.9842C8.6263 13.9844 8.57563 14.0055 8.53822 14.043C8.50081 14.0804 8.47968 14.131 8.47942 14.1839V15.0992C8.47968 15.1521 8.50081 15.2028 8.53822 15.2402C8.57563 15.2776 8.6263 15.2987 8.67921 15.299H8.71147C8.76438 15.2987 8.81505 15.2776 8.85246 15.2402C8.88987 15.2028 8.911 15.1521 8.91126 15.0992V14.1839C8.911 14.131 8.88987 14.0804 8.85246 14.043C8.81505 14.0055 8.76438 13.9844 8.71147 13.9842H8.67921ZM11.1155 15.6858H11.0833C10.761 15.6858 10.4968 15.4215 10.4968 15.0993V14.184C10.4968 13.8617 10.761 13.5975 11.0833 13.5975H11.1155C11.4378 13.5975 11.702 13.8617 11.702 14.184V15.0993C11.7021 15.4215 11.4378 15.6858 11.1155 15.6858ZM11.0833 13.9842C11.0304 13.9844 10.9798 14.0055 10.9423 14.043C10.9049 14.0804 10.8838 14.131 10.8835 14.1839V15.0992C10.8838 15.1521 10.9049 15.2028 10.9423 15.2402C10.9798 15.2776 11.0304 15.2987 11.0833 15.299H11.1156C11.1685 15.2987 11.2192 15.2776 11.2566 15.2402C11.294 15.2028 11.3151 15.1521 11.3154 15.0992V14.1839C11.3151 14.131 11.294 14.0804 11.2566 14.043C11.2192 14.0055 11.1685 13.9844 11.1156 13.9842H11.0833ZM12.6817 15.6858H12.6495C12.3272 15.6858 12.063 15.4215 12.063 15.0993V14.184C12.063 13.8617 12.3272 13.5975 12.6495 13.5975H12.6817C13.004 13.5975 13.2682 13.8617 13.2682 14.184V15.0993C13.2683 15.4215 13.004 15.6858 12.6817 15.6858ZM12.6495 13.9842C12.5966 13.9844 12.546 14.0055 12.5086 14.043C12.4711 14.0804 12.45 14.131 12.4497 14.1839V15.0992C12.45 15.1521 12.4711 15.2028 12.5086 15.2402C12.546 15.2776 12.5966 15.2987 12.6495 15.299H12.6818C12.7347 15.2987 12.7854 15.2776 12.8228 15.2402C12.8602 15.2028 12.8813 15.1521 12.8816 15.0992V14.1839C12.8813 14.131 12.8602 14.0804 12.8228 14.043C12.7854 14.0055 12.7347 13.9844 12.6818 13.9842H12.6495ZM14.2479 15.6858H14.2157C13.8934 15.6858 13.6292 15.4215 13.6292 15.0993V14.184C13.6292 13.8617 13.8934 13.5975 14.2157 13.5975H14.2479C14.5702 13.5975 14.8344 13.8617 14.8344 14.184V15.0993C14.8345 15.4215 14.5703 15.6858 14.2479 15.6858ZM14.2157 13.9842C14.1628 13.9844 14.1122 14.0055 14.0748 14.043C14.0373 14.0804 14.0162 14.131 14.016 14.1839V15.0992C14.0162 15.1521 14.0373 15.2028 14.0748 15.2402C14.1122 15.2776 14.1628 15.2987 14.2157 15.299H14.248C14.3009 15.2987 14.3516 15.2776 14.389 15.2402C14.4264 15.2028 14.4475 15.1521 14.4478 15.0992V14.1839C14.4475 14.131 14.4264 14.0804 14.389 14.043C14.3516 14.0055 14.3009 13.9844 14.248 13.9842H14.2157ZM15.8142 15.6858H15.7819C15.4596 15.6858 15.1954 15.4215 15.1954 15.0993V14.184C15.1954 13.8617 15.4596 13.5975 15.7819 13.5975H15.8142C16.1364 13.5975 16.4007 13.8617 16.4007 14.184V15.0993C16.4007 15.4215 16.1365 15.6858 15.8142 15.6858ZM15.782 13.9842C15.729 13.9844 15.6784 14.0055 15.641 14.043C15.6035 14.0804 15.5824 14.131 15.5822 14.1839V15.0992C15.5824 15.1521 15.6035 15.2028 15.641 15.2402C15.6784 15.2776 15.729 15.2987 15.782 15.299H15.8142C15.8671 15.2987 15.9178 15.2776 15.9552 15.2402C15.9926 15.2028 16.0137 15.1521 16.014 15.0992V14.1839C16.0137 14.131 15.9926 14.0804 15.9552 14.043C15.9178 14.0055 15.8671 13.9844 15.8142 13.9842H15.782Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
        "path",
        {
          d: "M18.2184 15.6857H18.1861C17.8639 15.6857 17.5996 15.4215 17.5996 15.0992V14.184C17.5996 13.8617 17.8639 13.5975 18.1861 13.5975H18.2184C18.5406 13.5975 18.8049 13.8617 18.8049 14.184V15.0992C18.8049 15.4214 18.5406 15.6857 18.2184 15.6857ZM18.1861 13.9841C18.1332 13.9844 18.0825 14.0055 18.0451 14.0429C18.0077 14.0803 17.9866 14.131 17.9863 14.1839V15.0992C17.9866 15.1521 18.0077 15.2028 18.0451 15.2402C18.0825 15.2776 18.1332 15.2987 18.1861 15.299H18.2184C18.2713 15.2987 18.3219 15.2776 18.3594 15.2402C18.3968 15.2028 18.4179 15.1521 18.4182 15.0992V14.1839C18.4179 14.131 18.3968 14.0803 18.3594 14.0429C18.3219 14.0055 18.2713 13.9844 18.2184 13.9841H18.1861ZM19.7846 15.6857H19.7524C19.4301 15.6857 19.1659 15.4215 19.1659 15.0992V14.184C19.1659 13.8617 19.4301 13.5975 19.7524 13.5975H19.7846C20.1068 13.5975 20.3711 13.8617 20.3711 14.184V15.0992C20.3711 15.4214 20.1068 15.6857 19.7846 15.6857ZM19.7524 13.9841C19.6995 13.9844 19.6488 14.0055 19.6114 14.0429C19.574 14.0803 19.5528 14.131 19.5526 14.1839V15.0992C19.5528 15.1521 19.574 15.2028 19.6114 15.2402C19.6488 15.2776 19.6995 15.2987 19.7524 15.299H19.7846C19.8375 15.2987 19.8881 15.2776 19.9256 15.2402C19.963 15.2028 19.9841 15.1521 19.9844 15.0992V14.1839C19.9841 14.131 19.963 14.0803 19.9256 14.0429C19.8881 14.0055 19.8375 13.9844 19.7846 13.9841H19.7524ZM21.3508 15.6857H21.3185C20.9963 15.6857 20.732 15.4215 20.732 15.0992V14.184C20.732 13.8617 20.9963 13.5975 21.3185 13.5975H21.3508C21.673 13.5975 21.9373 13.8617 21.9373 14.184V15.0992C21.9373 15.4214 21.673 15.6857 21.3508 15.6857ZM21.3186 13.9841C21.2657 13.9844 21.215 14.0055 21.1776 14.0429C21.1402 14.0803 21.119 14.131 21.1188 14.1839V15.0992C21.119 15.1521 21.1402 15.2028 21.1776 15.2402C21.215 15.2776 21.2657 15.2987 21.3186 15.299H21.3508C21.4037 15.2987 21.4544 15.2776 21.4918 15.2402C21.5292 15.2028 21.5504 15.1521 21.5506 15.0992V14.1839C21.5504 14.131 21.5292 14.0803 21.4918 14.0429C21.4544 14.0055 21.4037 13.9844 21.3508 13.9841H21.3186ZM22.917 15.6857H22.8847C22.5625 15.6857 22.2982 15.4215 22.2982 15.0992V14.184C22.2982 13.8617 22.5625 13.5975 22.8847 13.5975H22.917C23.2392 13.5975 23.5035 13.8617 23.5035 14.184V15.0992C23.5035 15.4214 23.2392 15.6857 22.917 15.6857ZM22.8848 13.9841C22.8319 13.9844 22.7812 14.0055 22.7438 14.0429C22.7064 14.0803 22.6852 14.131 22.685 14.1839V15.0992C22.6852 15.1521 22.7064 15.2028 22.7438 15.2402C22.7812 15.2776 22.8319 15.2987 22.8848 15.299H22.917C22.9699 15.2987 23.0206 15.2776 23.058 15.2402C23.0954 15.2028 23.1166 15.1521 23.1168 15.0992V14.1839C23.1166 14.131 23.0954 14.0803 23.058 14.0429C23.0206 14.0055 22.9699 13.9844 22.917 13.9841H22.8848ZM25.3211 15.6857H25.2889C24.9666 15.6857 24.7024 15.4215 24.7024 15.0992V14.184C24.7024 13.8617 24.9666 13.5975 25.2889 13.5975H25.3211C25.6434 13.5975 25.9076 13.8617 25.9076 14.184V15.0992C25.9076 15.4214 25.6434 15.6857 25.3211 15.6857ZM25.2889 13.9841C25.2359 13.9844 25.1853 14.0055 25.1479 14.0429C25.1104 14.0803 25.0893 14.131 25.0891 14.1839V15.0992C25.0893 15.1521 25.1104 15.2028 25.1479 15.2402C25.1853 15.2776 25.2359 15.2987 25.2889 15.299H25.3211C25.374 15.2987 25.4247 15.2776 25.4621 15.2402C25.4995 15.2028 25.5206 15.1521 25.5209 15.0992V14.1839C25.5206 14.131 25.4995 14.0803 25.4621 14.0429C25.4247 14.0055 25.374 13.9844 25.3211 13.9841H25.2889ZM26.8873 15.6857H26.8551C26.5329 15.6857 26.2686 15.4215 26.2686 15.0992V14.184C26.2686 13.8617 26.5329 13.5975 26.8551 13.5975H26.8873C27.2096 13.5975 27.4738 13.8617 27.4738 14.184V15.0992C27.4738 15.4214 27.2096 15.6857 26.8873 15.6857ZM26.8551 13.9841C26.8021 13.9844 26.7515 14.0055 26.7141 14.0429C26.6767 14.0803 26.6555 14.131 26.6553 14.1839V15.0992C26.6555 15.1521 26.6767 15.2028 26.7141 15.2402C26.7515 15.2776 26.8021 15.2987 26.8551 15.299H26.8873C26.9402 15.2987 26.9908 15.2776 27.0282 15.2402C27.0657 15.2028 27.0868 15.1521 27.087 15.0992V14.1839C27.0868 14.131 27.0657 14.0803 27.0282 14.0429C26.9908 14.0055 26.9402 13.9844 26.8873 13.9841H26.8551ZM28.4535 15.6857H28.4213C28.099 15.6857 27.8348 15.4215 27.8348 15.0992V14.184C27.8348 13.8617 28.099 13.5975 28.4213 13.5975H28.4535C28.7758 13.5975 29.04 13.8617 29.04 14.184V15.0992C29.04 15.4214 28.7758 15.6857 28.4535 15.6857ZM28.4213 13.9841C28.3684 13.9844 28.3177 14.0055 28.2803 14.0429C28.2429 14.0803 28.2218 14.131 28.2215 14.1839V15.0992C28.2218 15.1521 28.2429 15.2028 28.2803 15.2402C28.3177 15.2776 28.3684 15.2987 28.4213 15.299H28.4536C28.5065 15.2987 28.5571 15.2776 28.5946 15.2402C28.632 15.2028 28.6531 15.1521 28.6534 15.0992V14.1839C28.6531 14.131 28.632 14.0803 28.5946 14.0429C28.5571 14.0055 28.5065 13.9844 28.4536 13.9841H28.4213ZM30.0197 15.6857H29.9875C29.6652 15.6857 29.401 15.4215 29.401 15.0992V14.184C29.401 13.8617 29.6652 13.5975 29.9875 13.5975H30.0197C30.342 13.5975 30.6062 13.8617 30.6062 14.184V15.0992C30.6063 15.4214 30.342 15.6857 30.0197 15.6857ZM29.9875 13.9841C29.9346 13.9844 29.8839 14.0055 29.8465 14.0429C29.8091 14.0803 29.788 14.131 29.7877 14.1839V15.0992C29.788 15.1521 29.8091 15.2028 29.8465 15.2402C29.8839 15.2776 29.9346 15.2987 29.9875 15.299H30.0198C30.0727 15.2987 30.1234 15.2776 30.1608 15.2402C30.1982 15.2028 30.2193 15.1521 30.2196 15.0992V14.1839C30.2193 14.131 30.1982 14.0803 30.1608 14.0429C30.1234 14.0055 30.0727 13.9844 30.0198 13.9841H29.9875Z",
          fill: "white"
        }
      )
    ]
  }
);
var brandToIcon = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  "american-express": AmericanExpressIcon,
  discover: DiscoverIcon,
  jcb: JcbIcon,
  unionpay: UnionPayIcon,
  "diners-club": DinersClubIcon,
  default: GenericCardIcon
};
var normalizeBrandKey = (brand) => {
  const key = brand?.trim().toLowerCase() ?? "";
  switch (key) {
    case "amex":
    case "american express":
    case "american-express":
      return "american-express";
    case "diners":
    case "diners club":
    case "diners-club":
      return "diners-club";
    default:
      return key in brandToIcon ? key : "default";
  }
};
var BrandIcon = ({ brand, className }) => {
  const Icon = brandToIcon[normalizeBrandKey(brand)] || brandToIcon.default;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Icon, { className: cn("h-auto w-8.5 shrink-0", className) });
};
BrandIcon.displayName = "BrandIcon";
var variantClass = {
  default: "bg-neutral-1000",
  expired: "bg-status-error"
};
var CardChip = ({ label, variant }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  "div",
  {
    className: cn(
      "flex h-5 w-fit items-center rounded-full px-2.5",
      variantClass[variant]
    ),
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      Small,
      {
        xs: true,
        color: "white",
        weight: "demiBold",
        className: "whitespace-nowrap text-[11px]",
        children: label
      }
    )
  }
);
CardChip.displayName = "CardChip";
var CreditCard = ({
  card,
  isExpired,
  errorMsg,
  id,
  className
}) => {
  const cardNumber = `**** ${card.last4}`;
  const expiry = `${card.exp_month.padStart(2, "0")}/${card.exp_year.slice(-2)}`;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className, children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        id,
        className: cn(
          "flex flex-col gap-3.25 rounded-[10px] border bg-white p-3.5",
          errorMsg ? "border-status-error" : "border-brand-primary"
        ),
        children: [
          card.is_default && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: "flex justify-end", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardChip, { label: "Default card", variant: "default" }) }),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex items-center gap-2.5", children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BrandIcon, { brand: card.brand }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { weight: "demiBold", className: "whitespace-nowrap", children: cardNumber })
            ] }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", { className: "flex items-center gap-2.5", children: [
              isExpired && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardChip, { label: "Expired", variant: "expired" }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Small, { weight: "demiBold", color: "grey-dark", children: expiry })
            ] })
          ] }),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Small, { color: "neutral-900", children: card.name })
        ]
      }
    ),
    errorMsg && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMessage, { children: errorMsg })
  ] });
};
CreditCard.displayName = "CreditCard";
var Cvv = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({
    error = false,
    label = "Please enter the CVV number to verify your card",
    className,
    inputClassName,
    id,
    ...inputProps
  }, ref) => {
    const generatedId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    const inputId = id ?? generatedId;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
      "div",
      {
        className: cn(
          "flex items-center gap-3 rounded-[10px] bg-brand-subtle px-3.5 py-2",
          error && "bg-status-error",
          className
        ),
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            Small,
            {
              as: "label",
              htmlFor: inputId,
              className: "text-[12px] leading-[160%]",
              color: error ? "white" : "neutral-900",
              children: label
            }
          ),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
            Input,
            {
              ref,
              id: inputId,
              error,
              "aria-invalid": error || void 0,
              maxLength: 4,
              placeholder: "CVV",
              autoComplete: "cc-csc",
              inputMode: "numeric",
              className: cn(
                "h-8.5 w-13 shrink-0 px-2 text-center",
                !error && "border-brand-primary",
                inputClassName
              ),
              ...inputProps
            }
          )
        ]
      }
    );
  }
);
Cvv.displayName = "Cvv";
var chronologyMarkerVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("shrink-0 rounded-full bg-brand-primary", {
  variants: {
    variant: {
      index: "flex h-[46px] w-[46px] items-center justify-center",
      dot: "block h-[10px] w-[10px]"
    }
  },
  defaultVariants: { variant: "dot" }
});
var ChronologyMarker = ({
  variant,
  index,
  className
}) => {
  if (variant === "index") {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", { className: cn(chronologyMarkerVariants({ variant }), className), children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      Body,
      {
        as: "span",
        weight: "semibold",
        color: "neutral-0",
        className: "text-base leading-none",
        children: index
      }
    ) });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "span",
    {
      "aria-hidden": "true",
      className: cn(chronologyMarkerVariants({ variant }), className)
    }
  );
};
ChronologyMarker.displayName = "ChronologyMarker";
var chronologyItemVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("group/chronology-item relative flex", {
  variants: {
    orientation: {
      vertical: "flex-row pb-6 last:pb-0",
      horizontal: "shrink-0 basis-48 flex-col items-start pr-6 last:pr-0"
    },
    align: {
      left: "",
      right: ""
    }
  },
  compoundVariants: [
    { orientation: "vertical", align: "right", class: "flex-row-reverse" }
  ],
  defaultVariants: { orientation: "vertical", align: "left" }
});
var chronologyItemContentVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("", {
  variants: {
    orientation: {
      vertical: "min-w-0 flex-1 pl-6",
      horizontal: "w-full pt-3"
    },
    align: {
      left: "",
      right: ""
    }
  },
  compoundVariants: [
    { orientation: "vertical", align: "right", class: "pl-0 pr-4 text-right" }
  ],
  defaultVariants: { orientation: "vertical", align: "left" }
});
var chronologyConnectorVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)(
  "pointer-events-none absolute z-0 border-brand-editorial group-last/chronology-item:hidden",
  {
    variants: {
      orientation: {
        vertical: "left-[22px] top-[23px] h-full w-0 border-l-1",
        horizontal: "left-[23px] top-[22px] h-0 w-full border-t-1"
      },
      align: {
        left: "",
        right: ""
      },
      lineStyle: {
        solid: "border-solid",
        dashed: "border-dashed",
        dotted: "border-dotted",
        none: "hidden"
      }
    },
    compoundVariants: [
      {
        orientation: "vertical",
        align: "right",
        class: "left-auto right-[22px]"
      }
    ],
    defaultVariants: {
      orientation: "vertical",
      align: "left",
      lineStyle: "solid"
    }
  }
);
var CHRONOLOGY_MARKER_CELL = "relative z-10 flex h-[45px] w-[45px] shrink-0 items-center justify-center";
var ChronologyItem = ({
  children,
  marker,
  markerVariant,
  index,
  orientation = "vertical",
  align = "left",
  lineStyle = "solid",
  className,
  ...rest
}) => {
  const resolvedVariant = markerVariant ?? "dot";
  let markerNode;
  if (marker !== void 0) {
    markerNode = marker;
  } else if (resolvedVariant === "index" && index !== void 0) {
    markerNode = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChronologyMarker, { variant: "index", index });
  } else {
    markerNode = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChronologyMarker, { variant: "dot" });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(
    "li",
    {
      "data-orientation": orientation,
      className: cn(chronologyItemVariants({ orientation, align }), className),
      ...rest,
      children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "span",
          {
            "aria-hidden": "true",
            "data-chronology-connector": "",
            className: chronologyConnectorVariants({
              orientation,
              align,
              lineStyle
            })
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          "span",
          {
            "data-chronology-marker": resolvedVariant,
            className: CHRONOLOGY_MARKER_CELL,
            children: markerNode
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", { className: chronologyItemContentVariants({ orientation, align }), children })
      ]
    }
  );
};
ChronologyItem.displayName = "ChronologyItem";
var ChronologyLabel = ({
  children,
  className
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  Body,
  {
    weight: "semibold",
    color: "neutral-900",
    className: cn(
      "text-lg leading-7 group-data-[orientation=vertical]/chronology-item:pt-[calc(23px-0.5lh)]",
      className
    ),
    children
  }
);
ChronologyLabel.displayName = "ChronologyLabel";
var ChronologyContent = ({
  children,
  className
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
  Body,
  {
    as: "div",
    weight: "regular",
    color: "neutral-700",
    className: cn("text-lg", className),
    children
  }
);
ChronologyContent.displayName = "ChronologyContent";

// src/primitives/chronology/utils.ts
var isChronologyItem = (child) => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) && child.type === ChronologyItem;
};
var buildChildrenItems = (props) => {
  const { children, align, lineStyle, defaultMarker, orientation } = props;
  let itemOrdinal = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).map((child) => {
    if (!isChronologyItem(child)) {
      return child;
    }
    const ordinal = itemOrdinal++;
    const alignOrdinal = ordinal % 2 === 0 ? "left" : "right";
    const resolvedAlign = align === "alternate" ? alignOrdinal : align;
    const injected = {
      ...child.props.orientation === void 0 ? { orientation } : {},
      ...child.props.align === void 0 ? { align: resolvedAlign } : {},
      ...child.props.lineStyle === void 0 ? { lineStyle } : {},
      ...child.props.marker === void 0 && child.props.markerVariant === void 0 ? { markerVariant: defaultMarker } : {}
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, injected);
  });
};
var Chronology = ({
  children,
  orientation = "vertical",
  align = "left",
  lineStyle = "solid",
  defaultMarker = "dot",
  className,
  ...rest
}) => {
  const elements = buildChildrenItems({
    children,
    align,
    lineStyle,
    defaultMarker,
    orientation
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    "ol",
    {
      "data-orientation": orientation,
      "data-align": align,
      className: cn(
        "m-0 flex list-none p-0",
        orientation === "horizontal" ? "flex-row overflow-x-auto" : "flex-col",
        className
      ),
      ...orientation === "horizontal" ? { tabIndex: 0 } : {},
      ...rest,
      children: elements
    }
  );
};
Chronology.displayName = "Chronology";


//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map

/***/ })

}]);